import React, {useEffect, useRef, useState} from 'react'
import Spinner from 'react-bootstrap/Spinner';
import Container from 'react-bootstrap/Container';
import Label from 'react-bootstrap/FormLabel';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import {Link, useLocation, useNavigate} from "react-router-dom";
import Table from 'react-bootstrap/Table';
import ReMultiSelect from 'react-select';
import ReMultiSelectAnimated from 'react-select/animated';
import axios from 'axios';
import Cookies from 'js-cookie';
import {showToast as toast} from '../../toastManager';
import errorMessages from '../../errorMessages.js';
import {v4 as uuidv4} from 'uuid';
import Accordion from 'react-bootstrap/Accordion';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Breadcrumbs from '../../components/Breadcrumbs';
import ImageWithFallback from '../../components/ImageFallback';
import Modal from 'react-bootstrap/Modal';
import { abArmsEditable, canUseAbTesting } from '../../utils/abTesting';
import '../../ChatApp.css';
const getPlainText = (html) => {
    if (!html) return '';
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    return (tempDiv.textContent || tempDiv.innerText || '').trim();
};

function getMatchTypeLetter(matchType) {
    switch(matchType?.toLowerCase()) {
        case 'exact':
            return 'e';
        case 'phrase':
            return 'p';
        case 'broad':
            return 'b';
        default:
            return matchType || '';
    }
}

function ABTestVariantPersonalization({ViewedPage, shop_domain, app_url, allowed_pages_json}) {
    ViewedPage(28);
    const location = useLocation();
    const navigate = useNavigate();

    // No A/B Testing page access for this store (page ID 72): back to the campaign list.
    const abAllowed = canUseAbTesting(allowed_pages_json, shop_domain);
    useEffect(() => {
        if (!abAllowed) navigate('/campaign-summary', { replace: true });
    }, [abAllowed, navigate]);
    const previousPage = location.state?.previousPage || 'campaign-summary';
    const campaignData = location.state?.campaignData;
    // A variant's content can't change while its test runs (or once it has completed); it can while paused.
    const readOnlyVariant = !abArmsEditable(campaignData?.ab_test);
    const allCamapignTargetings = location.state?.allTargeting ? location.state?.allTargeting : [];
    const _currentUrl = campaignData?.landing_page_urls?.trim() || '';
    const _urlTargetings = (allCamapignTargetings && typeof allCamapignTargetings === 'object' && !Array.isArray(allCamapignTargetings))
        ? (allCamapignTargetings[_currentUrl] || [])
        : (allCamapignTargetings || []);
    const targetingItem = location.state?.targetingItem ? location.state?.targetingItem : {
        id: uuidv4(),
        name: `Untitled Variant`,
        status: 'enabled',
        targeting: [],
        value: []
    };
    // An A/B variant previews with its locked arm key: ?sxi_content=<arm key> is a preview the SDK
    // never enrolls, and the arm flag is written whatever the campaign status, so a separate UUID
    // preview flag would only duplicate it (the flag builder skips preview_targeting for A/B).
    const [generate_preview_contentKey, setGeneratePreviewContentKey] = useState(targetingItem?.targeting?.[0] || uuidv4());

    console.log("campaignData", campaignData);
    console.log("targetingItem", targetingItem);

    // Add new state and ref for editable title
    const [isEditingName, setIsEditingName] = useState(false);
    const targetAndContentInputRef = useRef(null);
    const [target_and_content_name, setTargetAndContentName] = useState(targetingItem?.name || "Untitled Variant");

    // Add status state and options
    const [status, setStatus] = useState({
        value: targetingItem?.status || 'enabled',
        label: targetingItem?.status ? targetingItem.status.charAt(0).toUpperCase() + targetingItem.status.slice(1) : 'Enabled'
    });

    // Custom styles for dropdowns to ensure they appear above other elements
    const dropdownStyles = {
        menuPortal: base => ({ ...base, zIndex: 9999 }),
        menu: provided => ({ ...provided, zIndex: 9999 })
    };

    // Add handlers for title editing
    const handleCampaignNameEdit = () => {
        setIsEditingName(true);
        setTimeout(() => {
            targetAndContentInputRef.current?.focus();
        }, 0);
    };

    const handleCampaignNameChange = (e) => {
        setTargetAndContentName(e.target.value);
    };

    const handleCampaignNameBlur = () => {
        setIsEditingName(false);
        if (!target_and_content_name?.trim()) {
            setTargetAndContentName("Untitled Variation");
        }
    };

    const handleCampaignNameKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleCampaignNameBlur();
        }
    };

    const [loading, setLoading] = useState(true);
    const [analyze_btn_loading, setAnalyzeBtnLoading] = useState(false);
    const [generate_btn_loading, setGenerateBtnLoading] = useState(false);
    const [show_landing_page, setShowLandingPageURL] = useState(false);
    const [urlCopied, setUrlCopied] = useState(false);
    const [apply_customization_btn_loading, setApplyCustomizeBtnLoading] = useState(false);
    const [is_section_personalization_enabled, setIsSectionPersonalizationEnabled] = useState(true);
    const [is_section_rearrangement_enabled, setIsSectionRearrangementEnabled] = useState(false);
    const [is_city_personalization_enabled, setIsCityPersonalizationEnabled] = useState(false);
    const [is_zip_code_personalization_enabled, setIsZipCodePersonalizationEnabled] = useState(false);
    const [isFormPersonalizationEnabled, setIsFormPersonalizationEnabled] = useState(false);
    const [isExitIntentPersonalizationEnabled, setIsExitIntentPersonalizationEnabled] = useState(false);
    const [suggestions, setSuggestions] = useState([]);
    const [selected_suggestion, setSelectedSuggestion] = useState(
        targetingItem && targetingItem?.value && targetingItem?.value?.customization && targetingItem?.value?.customization?.length > 0 ? 
        targetingItem?.value?.customization : 
        (campaignData && campaignData?.templates && campaignData.templates?.customized_sections ? 
            campaignData.templates.customized_sections.map((iter) => {
                if (iter.type === 'dropdown' || iter.type === 'form' || iter.type === 'exit_intent') {
                    return iter.options[0].value; // Default to first option for dropdowns and forms
                }
                if (iter.type === 'img' || iter.type === 'image' || iter.type === 'bg_img') {
                    return iter.value || "";
                }
                return ""; // Empty string for text sections
            })
            :
            []
        )
    );

    // Add state for rearrangement selections
    const [selected_rearrangement, setSelectedRearrangement] = useState(
        targetingItem && targetingItem?.value && targetingItem?.value?.rearrangement && targetingItem?.value?.rearrangement?.length > 0 ? 
        targetingItem?.value?.rearrangement : 
        [] // Initialize as empty array to allow users to add sections even when no data exists
    );
    const [showMobileRearrangement, setShowMobileRearrangement] = useState(targetingItem && targetingItem?.value && targetingItem?.value?.rearrangement_mobile && targetingItem?.value?.rearrangement_mobile?.length > 0 ? true : false);
    const [selected_rearrangement_mobile, setSelectedRearrangementMobile] = useState(
        targetingItem && targetingItem?.value && targetingItem?.value?.rearrangement_mobile && targetingItem?.value?.rearrangement_mobile?.length > 0 ?
        targetingItem?.value?.rearrangement_mobile :
        []
    );
    const [selected_theme, setSelectedTheme] = useState(targetingItem?.targeting?.[0] || ''); // New state for the selected_theme text area
    const [contentLocked, setContentLocked] = useState(!!targetingItem?.contentLocked);

    // Add state for accordion
    const [activeAccordion, setActiveAccordion] = useState(['0']);

    // Reference tab buttons: keep using the existing accordion eventKeys/state.
    const canShowSection =
        is_section_personalization_enabled &&
        campaignData &&
        campaignData?.templates &&
        campaignData?.templates?.customized_sections &&
        campaignData.templates.customized_sections.filter(section => section.type === 'dropdown').length > 0;

    const canShowForm =
        isFormPersonalizationEnabled &&
        campaignData?.templates?.customized_sections?.some(section => section.type === 'form');

    const canShowExitIntent =
        isExitIntentPersonalizationEnabled &&
        campaignData?.templates?.customized_sections?.some(section => section.type === 'exit_intent');

    const canShowRearrange =
        is_section_rearrangement_enabled && campaignData?.sections_rearrangement;

    const rearrangeEventKey =
        (isFormPersonalizationEnabled &&
            campaignData?.templates?.customized_sections?.some(section => section.type === 'form') &&
            isExitIntentPersonalizationEnabled &&
            campaignData?.templates?.customized_sections?.some(section => section.type === 'exit_intent') &&
            campaignData?.sections_rearrangement)
            ? "4"
            : (isFormPersonalizationEnabled &&
                campaignData?.templates?.customized_sections?.some(section => section.type === 'form'))
                ? "3"
                : (isExitIntentPersonalizationEnabled &&
                    campaignData?.templates?.customized_sections?.some(section => section.type === 'exit_intent'))
                    ? "3"
                    : "2";

    const previewEventKey =
        (isFormPersonalizationEnabled &&
            campaignData?.templates?.customized_sections?.some(section => section.type === 'form') &&
            isExitIntentPersonalizationEnabled &&
            campaignData?.templates?.customized_sections?.some(section => section.type === 'exit_intent') &&
            campaignData?.sections_rearrangement)
            ? "6"
            : (isFormPersonalizationEnabled &&
                campaignData?.templates?.customized_sections?.some(section => section.type === 'form') &&
                isExitIntentPersonalizationEnabled &&
                campaignData?.templates?.customized_sections?.some(section => section.type === 'exit_intent'))
                ? "5"
                : (isFormPersonalizationEnabled &&
                    campaignData?.templates?.customized_sections?.some(section => section.type === 'form') &&
                    campaignData?.sections_rearrangement)
                    ? "5"
                    : (isExitIntentPersonalizationEnabled &&
                        campaignData?.templates?.customized_sections?.some(section => section.type === 'exit_intent') &&
                        campaignData?.sections_rearrangement)
                        ? "5"
                        : (isFormPersonalizationEnabled &&
                            campaignData?.templates?.customized_sections?.some(section => section.type === 'form'))
                            ? "4"
                            : (isExitIntentPersonalizationEnabled &&
                                campaignData?.templates?.customized_sections?.some(section => section.type === 'exit_intent'))
                                ? "4"
                                : (campaignData?.sections_rearrangement)
                                    ? "4"
                                    : "3";

    const getVisibleTabs = () => {
        // Must match tab order in the UI (Targeting -> Section -> Form -> Exit -> Rearrange -> Preview)
        const tabs = ['0'];
        if (canShowSection) tabs.push('1');
        if (canShowForm) tabs.push('2');
        if (canShowExitIntent) tabs.push('3');
        if (canShowRearrange) tabs.push(rearrangeEventKey);
        tabs.push(previewEventKey);

        // Safety: de-dupe while keeping order
        return tabs.filter((tab, idx) => tabs.indexOf(tab) === idx);
    };

    // Add keyword-level data state
    const [keywordLevelData, setKeywordLevelData] = useState([]);

    // Simple word counter helper
    const countWords = (text) => {
        if (!text) return 0;
        return text
            .replace(/<[^>]*>/g, ' ')       // strip HTML tags
            .replace(/&nbsp;/gi, ' ')       // normalize HTML spaces
            .trim()
            .split(/\s+/)
            .filter(Boolean).length;
    };

    const normalizeWhitespace = (value) => {
        if (typeof value !== 'string') return value;
        return value.replace(/&nbsp;/gi, ' ').replace(/\s+/g, ' ').trim();
    };

    // Handle paste events to strip unwanted HTML tags
    const handlePaste = (e, fullIndex) => {
        e.preventDefault();
        const clipboardData = e.clipboardData || window.clipboardData;
        const pastedText = clipboardData.getData('text/plain');
        
        // Get selection
        const selection = window.getSelection();
        if (!selection.rangeCount) return;
        
        const range = selection.getRangeAt(0);
        range.deleteContents();
        
        // Insert plain text
        const textNode = document.createTextNode(pastedText);
        range.insertNode(textNode);
        
        // Move cursor to end of inserted text
        range.setStartAfter(textNode);
        range.collapse(true);
        selection.removeAllRanges();
        selection.addRange(range);
        
        // Trigger input event to update state
        const event = new Event('input', { bubbles: true });
        e.currentTarget.dispatchEvent(event);
    };

    // Asset library (Images) state
    const [showImageLibrary, setShowImageLibrary] = useState(false);
    const [imageAssets, setImageAssets] = useState([]);
    const [imageAssetsLoading, setImageAssetsLoading] = useState(false);
    const [imageAssetTargetIndex, setImageAssetTargetIndex] = useState(null);
    // Rich text editor refs and state
    const editorRefs = useRef({});
    const previousValidHtmlRef = useRef({});
    const wordLimitExceededRef = useRef({});
    const editorInitializedRef = useRef({});
    const [applyAllMap, setApplyAllMap] = useState({});
    const [showToolbarMap, setShowToolbarMap] = useState({});
    const setEditorRef = (idx, el) => {
        if (el) {
            editorRefs.current[idx] = el;
            // Set initial content if not already initialized and element exists
            if (!editorInitializedRef.current[idx] && el) {
                const value = (selected_suggestion && selected_suggestion[idx]) || '';
                if (value && el.innerHTML !== value) {
                    // Use requestAnimationFrame to set content after render, preventing cursor jump
                    requestAnimationFrame(() => {
                        if (el && document.activeElement !== el) {
                            el.innerHTML = value;
                            previousValidHtmlRef.current[idx] = value;
                            editorInitializedRef.current[idx] = true;
                        }
                    });
                } else {
                    editorInitializedRef.current[idx] = true;
                }
            }
        }
    };
    const execCmdOn = (idx, cmd, value = null) => {
        const el = editorRefs.current[idx];
        if (!el) return;
        el.focus();
        try {
            if (applyAllMap[idx]) {
                const range = document.createRange();
                range.selectNodeContents(el);
                const sel = window.getSelection();
                sel.removeAllRanges();
                sel.addRange(range);
            }
            document.execCommand(cmd, false, value);

            // Enforce word limit for this section after command
            const section = campaignData?.templates?.customized_sections?.[idx];
            // const maxWords = section?.max_words || null;
            const maxWords = null;
            const textContent = el.innerText || el.textContent || '';
            const wordCount = countWords(textContent);

            if (maxWords && wordCount > maxWords) {
                const prevHtml = previousValidHtmlRef.current[idx] || '';
                el.innerHTML = prevHtml;
                try {
                    const range = document.createRange();
                    range.selectNodeContents(el);
                    range.collapse(false);
                    const sel = window.getSelection();
                    sel.removeAllRanges();
                    sel.addRange(range);
                } catch (err) {}
                if (!wordLimitExceededRef.current[idx]) {
                    toast.error(`Max word limit of ${maxWords} exceeded for "${section?.label || 'this section'}".`);
                    wordLimitExceededRef.current[idx] = true;
                }
                return;
            }

            if (maxWords) {
                wordLimitExceededRef.current[idx] = false;
            }

            // sync back
            const html = el.innerHTML;
            const normalizedHtml = normalizeWhitespace(html);
            let temp = [...selected_suggestion];
            temp[idx] = normalizedHtml;
            setSelectedSuggestion(temp);
            previousValidHtmlRef.current[idx] = normalizedHtml;
        } catch (e) {}
    };
    const toggleApplyAll = (idx) => {
        setApplyAllMap(prev => ({...prev, [idx]: !prev[idx]}));
    };
    const toggleToolbar = (idx, show) => {
        setShowToolbarMap(prev => ({...prev, [idx]: (show === undefined ? !prev[idx] : show)}));
    };

    // Persist campaign updates to backend (Redis + Mongo)
    const persistCampaignToStore = async (updatedCampaign) => {
        const campaignsRes = await axios.get(`${app_url}/api/store/personalized_campaigns`, { withCredentials: true });
        let campaigns = campaignsRes?.data?.data || campaignsRes?.data || [];
        if (!Array.isArray(campaigns)) campaigns = [];
        const idx = campaigns.findIndex(c => c?.campaign_id === updatedCampaign?.campaign_id);
        if (idx > -1) {
            campaigns[idx] = updatedCampaign;
        } else {
            campaigns.push(updatedCampaign);
        }
        await axios.put(`${app_url}/api/store/personalized_campaigns`, campaigns, { withCredentials: true });
    };

    // Keep contenteditable elements in sync with selected_suggestion
    // without letting React re-render their innerHTML on every keystroke
    useEffect(() => {
        const refs = editorRefs.current || {};
        Object.keys(refs).forEach((key) => {
            const el = refs[key];
            if (!el) return;
            // Do not overwrite while user is actively typing in this editor
            if (document.activeElement === el) return;
            const value = (selected_suggestion && selected_suggestion[key]) || '';
            // Only update if content is different and editor has been initialized
            if (el.innerHTML !== value && editorInitializedRef.current[key]) {
                el.innerHTML = value;
                previousValidHtmlRef.current[key] = value;
            }
        });
    }, [selected_suggestion]);

    useEffect(() => {
        setLoading(false);
    }, []);

    // Fetch personalization settings and keyword-level data from backend 
    useEffect(() => {
        async function fetchPersonalizationSettings() {
            if (Cookies.get('shop') && shop_domain) {
                setLoading(true);
                try {
                    // Use same API as LandingPageOptimization
                    var created_at_max = new Date();
                    created_at_max.setDate(created_at_max.getDate() - 1);
                    var created_at_min = new Date(new Date().setDate(created_at_max.getDate() - 90));
                    const res = await axios.post(app_url + "/api/google/get_landing_page_optimization_data", {
                        shop_domain: shop_domain,
                        date_start: formatDate(created_at_min),
                        date_end: formatDate(created_at_max),
                        func_call_type: "redis",
                    }, {withCredentials: true});
                    const data = res.data.data;
                    // Set personalization flags from API response
                    setIsCityPersonalizationEnabled(data && data.is_city_personalization_enabled ? data.is_city_personalization_enabled : false);
                    setIsZipCodePersonalizationEnabled(data && data.is_zip_code_personalization_enabled ? data.is_zip_code_personalization_enabled : false);
                    setIsSectionPersonalizationEnabled(data && data.is_section_personalization_enabled !== undefined ? data.is_section_personalization_enabled : true);
                    setIsSectionRearrangementEnabled(data && data.is_section_rearrangement_enabled !== undefined ? data.is_section_rearrangement_enabled : false);
                    setIsFormPersonalizationEnabled(data && data.is_form_personalization_enabled !== undefined ? data.is_form_personalization_enabled : true);
                    setIsExitIntentPersonalizationEnabled(data && data.is_exit_intent_personalization_enabled !== undefined ? data.is_exit_intent_personalization_enabled : true);
                    // Store keyword-level data if present
                    if (data.lp_keywords_data) {
                        setKeywordLevelData(data.lp_keywords_data);
                    }
                } catch (err) {
                    setIsCityPersonalizationEnabled(false);
                    setIsZipCodePersonalizationEnabled(false);
                    setIsSectionPersonalizationEnabled(true);
                    setIsSectionRearrangementEnabled(false);
                    setIsFormPersonalizationEnabled(true);
                    setIsExitIntentPersonalizationEnabled(true);
                }
                setLoading(false);
            }
        }
        fetchPersonalizationSettings();
    }, [shop_domain, app_url]);

    const handleCustomizePageSubmit = async (is_drafted) => {
        // If saved then do not update the feature flag
        if(!is_drafted){
            return null;
        }
        setGenerateBtnLoading(true);
         // Validate selected_theme
        if (!selected_theme || !selected_theme.trim()) {
            toast.error(`Please add Content.`);
            setGenerateBtnLoading(false);
            if (!is_drafted) setApplyCustomizeBtnLoading(false);
            return;
        }

        for (let index = 0; index < selected_suggestion.length; index++) {
            const suggestion = selected_suggestion[index];
            const section = campaignData?.templates?.customized_sections?.[index];
            
            if (section?.type === 'text') {
                const plainText = getPlainText(suggestion);
                if (!plainText) {
                    toast.error(`Please add ${section.label || `field ${index + 1}`}`);
                    if (!is_drafted) setApplyCustomizeBtnLoading(false);
                    setGenerateBtnLoading(false);
                    return;
                }
            } else if (!suggestion || !suggestion.trim()) {
                const fieldName = section?.label || `field ${index + 1}`;
                toast.error(`Please add ${fieldName}`);
                if (!is_drafted) setApplyCustomizeBtnLoading(false);
                setGenerateBtnLoading(false);
                return;
            }
        }

        // Check keyword uniqueness
        let keywordsToCheck = [selected_theme];
        let temp_feature_flag_keys = generate_preview_contentKey;

        console.log("Temp Feature Flag Keys", temp_feature_flag_keys)
        // Build payload strictly in template order and include images
        const customizationPayload = (campaignData?.templates?.customized_sections || []).map((section, idx) => {
            const val = selected_suggestion?.[idx];
            if (val !== undefined && val !== null && String(val).length > 0) return val;
            if (section.type === 'dropdown' || section.type === 'form' || section.type === 'exit_intent') {
                return section.options?.[0]?.value || '';
            }
            return section.value || '';
        });
        const rearrangementPayload = is_section_rearrangement_enabled
            ? (selected_rearrangement || []).map((section, sectionIndex) => {return {
                section_id: section?.section_id, 
                section_name: section?.section_name, 
                section_query_selector: section?.section_query_selector,
                parent_query_selector: section?.parent_query_selector, 
                section_rearrangement: section?.section_rearrangement,
                section_category: section?.section_category,
                section_sub_category: section?.section_sub_category,
                display_rules: (section?.display_rules && typeof section?.display_rules === 'object' && !Array.isArray(section?.display_rules))
                    ? {
                        ...section.display_rules,
                        previous_section_query_selector: sectionIndex > 0 ? (selected_rearrangement?.[sectionIndex - 1]?.section_query_selector || '') : ''
                    }
                    : {}
            }})
            : {};
        const rearrangementMobilePayload = is_section_rearrangement_enabled
            ? (selected_rearrangement_mobile || []).map((section, sectionIndex) => {return {
                section_id: section?.section_id, 
                section_name: section?.section_name, 
                section_query_selector: section?.section_query_selector,
                parent_query_selector: section?.parent_query_selector, 
                section_rearrangement: section?.section_rearrangement,
                section_category: section?.section_category,
                section_sub_category: section?.section_sub_category,
                display_rules: (section?.display_rules && typeof section?.display_rules === 'object' && !Array.isArray(section?.display_rules))
                    ? {
                        ...section.display_rules,
                        previous_section_query_selector: sectionIndex > 0 ? (selected_rearrangement_mobile?.[sectionIndex - 1]?.section_query_selector || '') : ''
                    }
                    : {}
            }})
            : {};
        try {
            await axios.post(app_url + "/api/cux/generate-preview", {
                "landing_page_url": campaignData.landing_page_urls,
                "key": temp_feature_flag_keys,
                "value": {template_id: campaignData?.templates?.id || "", customization: customizationPayload, rearrangement: rearrangementPayload, rearrangement_mobile: rearrangementMobilePayload}
            }, {withCredentials: true});
            setGenerateBtnLoading(false);
        } catch (err) {
            toast.error(`${errorMessages["AI_GENERATION_ERROR"]["title"]}`);
            setGenerateBtnLoading(false);
            console.log(err);
        }
    }

    const handleSaveDescriptionToSheet = async (is_drafted) => {
        if(!is_drafted){
            setApplyCustomizeBtnLoading(true);
        }
        // --- Added validation for selected_theme (from CustomCampaignPersonalization.jsx) ---
            
        if (!selected_theme) {
            toast.error(`Please add Content.`);
            setApplyCustomizeBtnLoading(false);
            return;
        }
        if (!selected_suggestion || selected_suggestion.length === 0) {
            toast.error(`Please add personalized text.`);
            setApplyCustomizeBtnLoading(false);
            return;
        }

        const textSections = campaignData?.templates?.customized_sections?.filter(s => s.type === 'text') || [];
        
        for (let index = 0; index < textSections.length; index++) {
            const section = textSections[index];
            const sectionIndex = campaignData.templates.customized_sections.findIndex(s => s === section);
            const suggestion = selected_suggestion[sectionIndex];
            const plainText = getPlainText(suggestion);
            
            if (!plainText) {
                toast.error(`Please add ${section.label || `field ${index + 1}`}`);
                setApplyCustomizeBtnLoading(false);
                return;
            }

            // Location personalization validation (unchanged)
            let loc_personalization_dict = check_loc_personalization(suggestion);
            if (loc_personalization_dict.is_loc_personalized) {
                if (loc_personalization_dict.loc_personalization_type === "city" && !is_city_personalization_enabled) {
                    toast.error(`Please enable City personalization by going to Settings > Location Personalization`);
                    setApplyCustomizeBtnLoading(false);
                    return;
                }
                if (loc_personalization_dict.loc_personalization_type === "zip_code" && !is_zip_code_personalization_enabled) {
                    toast.error(`Please enable Zip code personalization by going to Settings > Location Personalization`);
                    setApplyCustomizeBtnLoading(false);
                    return;
                }
            }
        }


        try {
            if (Cookies.get('shop')) {
                await handleCustomizePageSubmit(is_drafted);
                let customized_exp_sheet_data = []
                let updatedCampaignData = campaignData;

                if (is_drafted) {
                    customized_exp_sheet_data = [selected_theme].map((theme_iter) => {
                        // For draft mode, use targeting_and_content.id
                        let updated_exp_url = campaignData.landing_page_urls + "?sxi_content=" + generate_preview_contentKey;
                        
                        // Map selected_suggestion to use labels for dropdowns
                        const mappedSuggestions = selected_suggestion.map((value, index) => {
            const section = campaignData.templates.customized_sections[index];
                            if (section && (section.type === 'dropdown' || section.type === 'form' || section.type === 'exit_intent')) {
                                // Find the option that matches this value and return its label
                                const option = section.options.find(opt => opt.value === value);
                                return option ? option.label : value;
                            }
                            return value;
                        });

                        return [
                            formatDate(new Date()),
                            target_and_content_name,
                            status.label,
                            theme_iter,
                            campaignData.landing_page_urls,
                            ...mappedSuggestions,
                            encodeURI(updated_exp_url)
                        ]
                    });
                } else {
                    if (selected_theme) {
                        const contentKey = selected_theme;
                        customized_exp_sheet_data = [contentKey].map((theme_iter) => {                                
                            // Map selected_suggestion to use labels for dropdowns
                            const mappedSuggestions = selected_suggestion.map((value, index) => {
            const section = campaignData.templates.customized_sections[index];
                                if (section && (section.type === 'dropdown' || section.type === 'form' || section.type === 'exit_intent')) {
                                    // Find the option that matches this value and return its label
                                    const option = section.options.find(opt => opt.value === value);
                                    return option ? option.label : value;
                                }
                                return value;
                            });

                            return [
                                formatDate(new Date()),
                                target_and_content_name,
                                status.label,
                                theme_iter,
                                campaignData.landing_page_urls,
                                ...mappedSuggestions,
                                encodeURI(campaignData.landing_page_urls + "?sxi_content=" + theme_iter)
                            ];
                        });
                        console.log("Customized Exp Sheet Data", customized_exp_sheet_data)

                        // Check if we're editing an existing targeting item
                        if (targetingItem && targetingItem.id) {
                            // Update existing targeting item
                            const updatedTargeting = campaignData.targeting_and_content.filter(item => item.id !== targetingItem.id);
                            updatedCampaignData = {
                                ...campaignData,
                                targeting_and_content: [
                                    ...(updatedTargeting || []),
                                    {
                                        id: targetingItem.id,
                                        name: target_and_content_name || 'Untitled Variant',
                                        status: status.value,
                                        ab_arm: targetingItem.ab_arm,
                                        targeting: [selected_theme],
                                        value: {
                                            customization: selected_suggestion,
                                            rearrangement: is_section_rearrangement_enabled ? selected_rearrangement : [],
                                            rearrangement_mobile: is_section_rearrangement_enabled ? selected_rearrangement_mobile : []
                                        },
                                        preview_targeting: generate_preview_contentKey,
                                        lpPreview: `${campaignData.landing_page_urls}?sxi_content=${generate_preview_contentKey}`,
                                        lpFinalUrl: `${campaignData.landing_page_urls}?sxi_content=${contentKey}`,
                                        contentLocked: true
                                    }
                                ]
                            };
                        } else {
                            // Create new targeting data only if we're not editing
                            const newId = uuidv4();
                            const newTargeting = {
                                id: newId,
                                name: target_and_content_name || 'Untitled Variant',
                                status: status.value,
                                ab_arm: targetingItem.ab_arm,
                                targeting: [selected_theme],
                                value: {
                                    customization: selected_suggestion,
                                    rearrangement: is_section_rearrangement_enabled ? selected_rearrangement : [],
                                    rearrangement_mobile: is_section_rearrangement_enabled ? selected_rearrangement_mobile : []
                                },
                                preview_targeting: generate_preview_contentKey,
                                lpPreview: `${campaignData.landing_page_urls}?sxi_content=${generate_preview_contentKey}`,
                                lpFinalUrl: `${campaignData.landing_page_urls}?sxi_content=${contentKey}`,
                                contentLocked: true
                            };
                            // Update campaign data with new targeting
                            updatedCampaignData = {
                                ...campaignData,
                                targeting_and_content: [
                                    ...(campaignData?.targeting_and_content || []),
                                    newTargeting
                                ]
                            };
                        }
                    }
                }
                console.log("Updated Campaign Data", updatedCampaignData)

                // Publish (replace prior save flow) when not draft
                if (!is_drafted) {
                    try {
                        await axios.post(`${app_url}/api/cux/publish-campaign`, { campaignData: updatedCampaignData }, { withCredentials: true });
                        setContentLocked(true);
                        setApplyCustomizeBtnLoading(false);
                        setShowLandingPageURL(true);
                        navigate('/ab-testing-campaign', {
                            state: {
                                campaignData: updatedCampaignData,
                                allTargeting: {
                                    ...allCamapignTargetings,
                                    [_currentUrl]: [...new Set([..._urlTargetings, selected_theme.toLowerCase(), generate_preview_contentKey.toLowerCase()])]
                                }
                            }
                        });
                    } catch (err) {
                        console.error('Error publishing campaign', err);
                        setApplyCustomizeBtnLoading(false);
                        toast.error(errorMessages["DATA_SAVE_ERROR"]?.title || "Failed to publish campaign");
                    }
                } else {
                    setApplyCustomizeBtnLoading(false);
                    setShowLandingPageURL(true);
                }
            }
        } catch (err) {
            setApplyCustomizeBtnLoading(false);
            toast.error(`${errorMessages["SHEET_UPLOAD_FAILED"]["title"]}`);
            console.log(err)
        }
    }

    const handleBack = () => {
        if (previousPage === 'ab-testing-campaign') {
            navigate('/ab-testing-campaign', {
                state: {
                    campaignData: campaignData,
                    allTargeting: {
                        ...allCamapignTargetings,
                        [_currentUrl]: [...new Set([..._urlTargetings, selected_theme.toLowerCase(), generate_preview_contentKey.toLowerCase()])]
                    }
                }
            });
        } else {
            navigate('/campaign-summary');
        }
    };

    // Define width calculation variables for responsive UI
    const textSections = campaignData?.templates?.customized_sections?.filter(s => s.type === 'text') || [];
    const textSectionsCount = textSections.length;
    const textSectionWidth = textSectionsCount >= 3 ? "calc(100% / 3)" : (textSectionsCount === 2 ? "50%" : "100%");

    // Combined content sections (text + images) to preserve order and show in one row
    const contentSectionsForRow = campaignData?.templates?.customized_sections?.filter(s => (s.type === 'text' || s.type === 'img' || s.type === 'image' || s.type === 'bg_img')) || [];
    const contentSectionCount = contentSectionsForRow.length;
    const contentSectionWidth = contentSectionCount >= 3 ? "calc(100% / 3)" : (contentSectionCount === 2 ? "50%" : "100%");

    const dropdownSections = campaignData?.templates?.customized_sections?.filter(s => s.type === 'dropdown') || [];
    const dropdownSectionsCount = dropdownSections.length;
    const dropdownSectionWidth = dropdownSectionsCount >= 3 ? "calc(100% / 3)" : (dropdownSectionsCount === 2 ? "50%" : "100%");

    const suggestionsHeaders = suggestions[0] || [];
    const suggestionsColCount = suggestionsHeaders.length;
    const suggestionsColWidth = suggestionsColCount >= 3 ? "calc(100% / 3)" : (suggestionsColCount === 2 ? "50%" : "100%");

    // Add dropdown change handler
    const handleDropdownChange = (sectionIndex, value) => {
        let temp_selected_suggestion = [...selected_suggestion];
        temp_selected_suggestion[sectionIndex] = normalizeWhitespace(value);
        setSelectedSuggestion(temp_selected_suggestion);
    };

    // Add rearrangement dropdown change handler (preserve display_rules when changing section)
    const handleRearrangementChange = (sectionIndex, value) => {
        let temp_selected_rearrangement = [...selected_rearrangement];
        const current = temp_selected_rearrangement[sectionIndex];
        temp_selected_rearrangement[sectionIndex] = { ...value, display_rules: current?.display_rules ?? {} };

        // Update next section's dependency if it has display_rules
        const nextIndex = sectionIndex + 1;
        if (nextIndex < temp_selected_rearrangement.length &&
            temp_selected_rearrangement[nextIndex]?.display_rules?.type) {
            temp_selected_rearrangement[nextIndex] = {
                ...temp_selected_rearrangement[nextIndex],
                display_rules: {
                    ...temp_selected_rearrangement[nextIndex].display_rules,
                    previous_section_query_selector:
                        temp_selected_rearrangement[sectionIndex]?.section_query_selector || ''
                }
            };
        }

        setSelectedRearrangement(temp_selected_rearrangement);
    };

    // Add handler for deleting rearrangement section
    const handleDeleteRearrangement = (index) => {
        let temp_selected_rearrangement = [...selected_rearrangement];
        temp_selected_rearrangement.splice(index, 1);

        // Update the section now at the deleted index if it has display_rules
        if (index < temp_selected_rearrangement.length &&
            temp_selected_rearrangement[index]?.display_rules?.type) {
            const newPredecessorSelector = index > 0
                ? (temp_selected_rearrangement[index - 1]?.section_query_selector || '')
                : '';
            temp_selected_rearrangement[index] = {
                ...temp_selected_rearrangement[index],
                display_rules: {
                    ...temp_selected_rearrangement[index].display_rules,
                    previous_section_query_selector: newPredecessorSelector
                }
            };
        }

        setSelectedRearrangement(temp_selected_rearrangement);
    };

    // Add handler for adding new rearrangement section after a specific index
    const handleAddRearrangement = (index) => {
        const availableOptions = get_rearrangement_options(campaignData, selected_rearrangement);
        if (availableOptions.length > 0) {
            let temp_selected_rearrangement = [...selected_rearrangement];
            // For empty array, insert at index 0, otherwise insert after the specified index
            const insertIndex = temp_selected_rearrangement.length === 0 ? 0 : index + 1;
            temp_selected_rearrangement.splice(insertIndex, 0, availableOptions[0].value);

            // Update next section's dependency if it has display_rules
            const nextIndex = insertIndex + 1;
            if (nextIndex < temp_selected_rearrangement.length &&
                temp_selected_rearrangement[nextIndex]?.display_rules?.type) {
                temp_selected_rearrangement[nextIndex] = {
                    ...temp_selected_rearrangement[nextIndex],
                    display_rules: {
                        ...temp_selected_rearrangement[nextIndex].display_rules,
                        previous_section_query_selector:
                            temp_selected_rearrangement[insertIndex]?.section_query_selector || ''
                    }
                };
            }

            setSelectedRearrangement(temp_selected_rearrangement);
        }
    };

    const handleRearrangementChangeMobile = (sectionIndex, value) => {
        let temp = [...selected_rearrangement_mobile];
        const current = temp[sectionIndex];
        temp[sectionIndex] = { ...value, display_rules: current?.display_rules ?? {} };

        // Update next section's dependency if it has display_rules
        const nextIndex = sectionIndex + 1;
        if (nextIndex < temp.length && temp[nextIndex]?.display_rules?.type) {
            temp[nextIndex] = {
                ...temp[nextIndex],
                display_rules: {
                    ...temp[nextIndex].display_rules,
                    previous_section_query_selector:
                        temp[sectionIndex]?.section_query_selector || ''
                }
            };
        }

        setSelectedRearrangementMobile(temp);
    };
    const handleDeleteRearrangementMobile = (index) => {
        let temp = [...selected_rearrangement_mobile];
        temp.splice(index, 1);

        // Update the section now at the deleted index if it has display_rules
        if (index < temp.length && temp[index]?.display_rules?.type) {
            const newPredecessorSelector = index > 0
                ? (temp[index - 1]?.section_query_selector || '')
                : '';
            temp[index] = {
                ...temp[index],
                display_rules: {
                    ...temp[index].display_rules,
                    previous_section_query_selector: newPredecessorSelector
                }
            };
        }

        setSelectedRearrangementMobile(temp);
    };
    const handleAddRearrangementMobile = (index) => {
        const availableOptions = get_rearrangement_options(campaignData, selected_rearrangement_mobile);
        if (availableOptions.length > 0) {
            let temp = [...selected_rearrangement_mobile];
            const insertIndex = temp.length === 0 ? 0 : index + 1;
            temp.splice(insertIndex, 0, availableOptions[0].value);

            // Update next section's dependency if it has display_rules
            const nextIndex = insertIndex + 1;
            if (nextIndex < temp.length && temp[nextIndex]?.display_rules?.type) {
                temp[nextIndex] = {
                    ...temp[nextIndex],
                    display_rules: {
                        ...temp[nextIndex].display_rules,
                        previous_section_query_selector:
                            temp[insertIndex]?.section_query_selector || ''
                    }
                };
            }

            setSelectedRearrangementMobile(temp);
        }
    };

    const [sectionSettingsPopoverOpen, setSectionSettingsPopoverOpen] = useState(null);
    const [hoveredSectionImage, setHoveredSectionImage] = useState(null);

    const handleAddDisplayRule = (view, sectionIndex, { type, seconds }) => {
        const sec = parseInt(seconds, 10);
        if (!Number.isFinite(sec) || sec <= 0) return;
        if (view === 'desktop') {
            const temp = [...selected_rearrangement];
            const currentSection = temp[sectionIndex] || {};
            const newSection = {
                ...currentSection,
                display_rules: {
                    type,
                    seconds: sec,
                    previous_section_query_selector: currentSection?.section_query_selector || ''
                }
            };
            temp.splice(sectionIndex + 1, 0, newSection);

            // Update dependency for the section now after the new one
            const afterNewIndex = sectionIndex + 2;
            if (afterNewIndex < temp.length && temp[afterNewIndex]?.display_rules?.type) {
                temp[afterNewIndex] = {
                    ...temp[afterNewIndex],
                    display_rules: {
                        ...temp[afterNewIndex].display_rules,
                        previous_section_query_selector:
                            newSection?.section_query_selector || ''
                    }
                };
            }

            setSelectedRearrangement(temp);
        } else {
            const temp = [...selected_rearrangement_mobile];
            const currentSection = temp[sectionIndex] || {};
            const newSection = {
                ...currentSection,
                display_rules: {
                    type,
                    seconds: sec,
                    previous_section_query_selector: currentSection?.section_query_selector || ''
                }
            };
            temp.splice(sectionIndex + 1, 0, newSection);

            // Update dependency for the section now after the new one
            const afterNewIndex = sectionIndex + 2;
            if (afterNewIndex < temp.length && temp[afterNewIndex]?.display_rules?.type) {
                temp[afterNewIndex] = {
                    ...temp[afterNewIndex],
                    display_rules: {
                        ...temp[afterNewIndex].display_rules,
                        previous_section_query_selector:
                            newSection?.section_query_selector || ''
                    }
                };
            }

            setSelectedRearrangementMobile(temp);
        }
        setSectionSettingsPopoverOpen(null);
    };

    // Helpers for image asset library
    const getFilePreviewUrl = (asset) => {
        if (!asset) return '';
        return asset.publicUrl || asset.url || '';
    };

    const openImageAssetLibrary = async (targetIndex) => {
        setImageAssetTargetIndex(targetIndex);
        setShowImageLibrary(true);
        setImageAssetsLoading(true);
        try {
            const res = await axios.post(app_url + "/api/assets/get_all", {
                shop_domain: shop_domain
            });
            const all = res?.data?.data || [];
            const imgs = all.filter(a => a.type === 'Image');
            setImageAssets(imgs);
        } catch (e) {
            setImageAssets([]);
        } finally {
            setImageAssetsLoading(false);
        }
    };

    const handleSelectImageAsset = (asset) => {
        const url = getFilePreviewUrl(asset);
        let temp = [...selected_suggestion];
        if (imageAssetTargetIndex !== null && imageAssetTargetIndex !== undefined) {
            temp[imageAssetTargetIndex] = normalizeWhitespace(url);
            setSelectedSuggestion(temp);
        }
        setShowImageLibrary(false);
        setImageAssetTargetIndex(null);
    };

    const getImageTypeFromUrl = (url) => {
        if (!url) return '';
        try {
            const clean = url.split('?')[0];
            const ext = (clean.split('.').pop() || '').toLowerCase();
            const known = ['jpg','jpeg','png','webp','gif','svg','bmp','avif'];
            if (known.includes(ext)) return ext.toUpperCase();
        } catch (e) {}
        return 'IMAGE';
    };

    const MobileIcon = () => (
        <svg viewBox="0 0 24 24" aria-hidden="true" style={{ width: '14px', height: '14px' }}>
            <rect x="7.5" y="3" width="9" height="18" rx="2.5" ry="2.5" fill="none" stroke="currentColor" strokeWidth="1.8"></rect>
            <circle cx="12" cy="18.5" r="0.9" fill="currentColor"></circle>
        </svg>
    );


    return (
        <div className='main-container'>
            {!shop_domain ?
                <div className='go_to_shopify_admin_div'>
                    <h5 style={{display: 'inline-block'}}>!! Go to Shopify Admin and open our app !!</h5>
                </div>
                :
                <>
                    {!loading ?
                        <>
                            {/* <Breadcrumbs campaignData={campaignData} /> */}
                            <div className='custom-campaign-personalization-title'>
                                <div className="d-flex justify-content-between align-items-start w-100">
                                                    <div className="d-flex flex-column">
                                                        {/* Title line: keep edit icon adjacent to the main title only */}
                                                        <div className="d-flex align-items-center gap-2">
                                                            {isEditingName ? (
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={target_and_content_name}
                                                                    onChange={handleCampaignNameChange}
                                                                    onBlur={handleCampaignNameBlur}
                                                                    onKeyDown={handleCampaignNameKeyDown}
                                                                    ref={targetAndContentInputRef}
                                                                    style={{
                                                                        fontSize: '1.25rem',
                                                                        fontWeight: 'bold',
                                                                        width: 'auto',
                                                                        minWidth: '180px'
                                                                    }}
                                                                />
                                                            ) : (
                                                                <OverlayTrigger
                                                                    placement="bottom"
                                                                    overlay={
                                                                        <Tooltip id="campaign-title-description-tooltip" className="sxi-campaign-edit-tooltip single-line-tooltip" style={{marginLeft: '4rem'}}>
                                                                            Configure your AI-powered personalization campaign
                                                                        </Tooltip>
                                                                    }
                                                                >
                                                                    <h2 style={{
                                                                        marginBottom: 0,
                                                                        fontSize: '1.25rem',
                                                                        fontWeight: 'bold',
                                                                        cursor: 'help'
                                                                    }}>{target_and_content_name}</h2>
                                                                </OverlayTrigger>
                                                            )}

                                                            <OverlayTrigger
                                                                placement="top"
                                                                overlay={
                                                                    <Tooltip id="campaign-title-edit-tooltip" className="sxi-campaign-edit-tooltip">
                                                                        Edit the title by clicking on the icon
                                                                    </Tooltip>
                                                                }
                                                            >
                                                                <button
                                                                    className="btn btn-sm btn-link p-0"
                                                                    onClick={handleCampaignNameEdit}
                                                                >
                                                                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M11 4H6.8C5.11984 4 4.27976 4 3.63803 4.32698C3.07354 4.6146 2.6146 5.07354 2.32698 5.63803C2 6.27976 2 7.11984 2 8.8V17.2C2 18.8802 2 19.7202 2.32698 20.362C2.6146 20.9265 3.07354 21.3854 3.63803 21.673C4.27976 22 5.11984 22 6.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9265 19.673 20.362C20 19.7202 20 18.8802 20 17.2V13M7.99997 16H9.67452C10.1637 16 10.4083 16 10.6385 15.9447C10.8425 15.8957 11.0376 15.8149 11.2166 15.7053C11.4184 15.5816 11.5914 15.4086 11.9373 15.0627L21.5 5.5C22.3284 4.67157 22.3284 3.32843 21.5 2.5C20.6716 1.67157 19.3284 1.67157 18.5 2.5L8.93723 12.0627C8.59133 12.4086 8.41838 12.5816 8.29469 12.7834C8.18504 12.9624 8.10423 13.1575 8.05523 13.3615C7.99997 13.5917 7.99997 13.8363 7.99997 14.3255V16Z" stroke="#AAAAAA" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                                    </svg>
                                                                </button>
                                                            </OverlayTrigger>
                                                        </div>

                                                    </div>

                                    <div className="d-flex align-items-center">
                                        <span className='campaign-tag-new mt-1 me-2'>A/B Testing · {targetingItem.ab_arm}</span>
                                    </div>
                                </div>
                            </div>

                            <Container className='my-4'>
                                <div className="tab-container mt-4">
                                    <div className="tab-navigation">
                                        <button
                                            type="button"
                                            className={`tab-button ${activeAccordion.includes('0') ? 'active' : ''}`}
                                            onClick={() => setActiveAccordion(['0'])}
                                        >
                                            <svg width="18" height="18" viewBox="0 0 18 18" fill="currentColor" className="tab-icon" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M9 16.5C7.9625 16.5 6.9875 16.303 6.075 15.909C5.1625 15.515 4.36875 14.9808 3.69375 14.3063C3.01875 13.6318 2.4845 12.838 2.091 11.925C1.6975 11.012 1.5005 10.037 1.5 9C1.4995 7.963 1.6965 6.988 2.091 6.075C2.4855 5.162 3.01975 4.36825 3.69375 3.69375C4.36775 3.01925 5.1615 2.485 6.075 2.091C6.9885 1.697 7.9635 1.5 9 1.5C10.0365 1.5 11.0115 1.697 11.925 2.091C12.8385 2.485 13.6323 3.01925 14.3063 3.69375C14.9803 4.36825 15.5148 5.162 15.9098 6.075C16.3048 6.988 16.5015 7.963 16.5 9C16.4985 10.037 16.3015 11.012 15.909 11.925C15.5165 12.838 14.9823 13.6318 14.3063 14.3063C13.6303 14.9808 12.8365 15.5152 11.925 15.9097C11.0135 16.3042 10.0385 16.501 9 16.5ZM9 15C10.675 15 12.0938 14.4187 13.2563 13.2562C14.4187 12.0937 15 10.675 15 9C15 7.325 14.4187 5.90625 13.2563 4.74375C12.0938 3.58125 10.675 3 9 3C7.325 3 5.90625 3.58125 4.74375 4.74375C3.58125 5.90625 3 7.325 3 9C3 10.675 3.58125 12.0937 4.74375 13.2562C5.90625 14.4187 7.325 15 9 15ZM9 13.5C7.75 13.5 6.6875 13.0625 5.8125 12.1875C4.9375 11.3125 4.5 10.25 4.5 9C4.5 7.75 4.9375 6.6875 5.8125 5.8125C6.6875 4.9375 7.75 4.5 9 4.5C10.25 4.5 11.3125 4.9375 12.1875 5.8125C13.0625 6.6875 13.5 7.75 13.5 9C13.5 10.25 13.0625 11.3125 12.1875 12.1875C11.3125 13.0625 10.25 13.5 9 13.5ZM9 12C9.825 12 10.5313 11.7063 11.1188 11.1187C11.7063 10.5312 12 9.825 12 9C12 8.175 11.7063 7.46875 11.1188 6.88125C10.5313 6.29375 9.825 6 9 6C8.175 6 7.46875 6.29375 6.88125 6.88125C6.29375 7.46875 6 8.175 6 9C6 9.825 6.29375 10.5312 6.88125 11.1187C7.46875 11.7063 8.175 12 9 12ZM9 10.5C8.5875 10.5 8.2345 10.3533 7.941 10.0597C7.6475 9.76625 7.5005 9.413 7.5 9C7.4995 8.587 7.6465 8.234 7.941 7.941C8.2355 7.648 8.5885 7.501 9 7.5C9.4115 7.499 9.76475 7.646 10.0598 7.941C10.3548 8.236 10.5015 8.589 10.5 9C10.4985 9.411 10.3518 9.76425 10.0598 10.0597C9.76775 10.3553 9.4145 10.502 9 10.5Z" fill="currentColor"/>
                                            </svg>

                                            Select and Modify Content
                                        </button>

                                        {canShowSection && (
                                            <button
                                                type="button"
                                                className={`tab-button ${activeAccordion.includes('1') ? 'active' : ''}`}
                                                onClick={() => setActiveAccordion(['1'])}
                                            >
                                                <svg width="20" height="20" viewBox="0 0 16 18" fill="currentColor" className="tab-icon" aria-hidden="true">
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M2.56681 0.5C2.12479 0.5 1.70086 0.675595 1.3883 0.988155C1.07574 1.30072 0.900146 1.72464 0.900146 2.16667V13.8333C0.900146 14.2754 1.07574 14.6993 1.3883 15.0118C1.70086 15.3244 2.12479 15.5 2.56681 15.5H14.2335C14.6755 15.5 15.0994 15.3244 15.412 15.0118C15.7246 14.6993 15.9001 14.2754 15.9001 13.8333V2.16667C15.9001 1.72464 15.7246 1.30072 15.412 0.988155C15.0994 0.675595 14.6755 0.5 14.2335 0.5H2.56681ZM7.56681 2.16667H2.56681V6.33333H7.56681V2.16667ZM2.56681 8H7.56681C8.00884 8 8.43276 7.8244 8.74532 7.51184C9.05788 7.19928 9.23348 6.77536 9.23348 6.33333V2.16667H14.2335V13.8333H2.56681V8Z" />
                                                </svg>
                                                Select Section
                                            </button>
                                        )}

                                        {canShowForm && (
                                            <button
                                                type="button"
                                                className={`tab-button ${activeAccordion.includes('2') ? 'active' : ''}`}
                                                onClick={() => setActiveAccordion(['2'])}
                                            >
                                                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" className="tab-icon" aria-hidden="true">
                                                    <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
                                                </svg>
                                                Select Form
                                            </button>
                                        )}

                                        {canShowExitIntent && (
                                            <button
                                                type="button"
                                                className={`tab-button ${activeAccordion.includes('3') ? 'active' : ''}`}
                                                onClick={() => setActiveAccordion(['3'])}
                                            >
                                                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" className="tab-icon" aria-hidden="true">
                                                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                                </svg>
                                                Select Exit Intent
                                            </button>
                                        )}

                                        {canShowRearrange && (
                                            <button
                                                type="button"
                                                className={`tab-button ${activeAccordion.includes(rearrangeEventKey) ? 'active' : ''}`}
                                                onClick={() => setActiveAccordion([rearrangeEventKey])}
                                            >
                                            <svg width="20" height="20" viewBox="0 0 18 18" fill="currentColor" className="tab-icon" aria-hidden="true">
                                                <g clipPath="url(#ccpClipRearrangeTab)">
                                                    <path d="M1.125 2.25H13.5H1.125ZM1.125 15.75H13.5H1.125ZM4.5 9H16.875H4.5Z" fill="currentColor" />
                                                    <path d="M1.125 2.25H13.5M1.125 15.75H13.5M4.5 9H16.875" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                                    </g>
                                                    <defs>
                                                        <clipPath id="ccpClipRearrangeTab">
                                                            <rect width="18" height="18" fill="white" />
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                                Rearrange Sections
                                            </button>
                                        )}

                                        <button
                                            type="button"
                                            className={`tab-button ${activeAccordion.includes(previewEventKey) ? 'active' : ''}`}
                                            onClick={() => setActiveAccordion([previewEventKey])}
                                        >
                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" className="tab-icon" aria-hidden="true">
                                                <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
                                            </svg>
                                            Generate Preview
                                        </button>
                                    </div>

                                    <div className="tab-content">
                                        <Accordion className="ccp-accordion" activeKey={activeAccordion}
                                                   onSelect={(keys) => setActiveAccordion(keys)}>
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>
                                            <div className="ccp-accordion-header-inner">
                                                <div className="ccp-accordion-header-left">
                                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" className="ccp-section-icon" aria-hidden="true">
                                                        <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
                                                    </svg>
                                                    <span className="ccp-accordion-header-title">Select Targeting and Modify Content</span>
                                                </div>
                                                <span className={`ccp-accordion-chevron ${activeAccordion.includes('0') ? 'open' : ''}`} aria-hidden="true">
                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                        <path d="M4.5 6L8 9.5L11.5 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                </span>
                                            </div>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <Row className='justify-content-md-left'>
                                                <Col className='p-2' xs={12}>
                                                    <Label className="charts_filter_label" style={{marginBottom: '0px'}}>sxi_content (fixed for this variant)</Label>
                                                    <textarea
                                                        readOnly
                                                        disabled
                                                        className='custom-input-landing-page'
                                                        value={selected_theme}
                                                        rows={1}
                                                        style={{width: '600px', height: '35px', flexGrow: 0, padding: "3px 10px"}}
                                                    />
                                                </Col>
                                            </Row>

                                            {/* Unified content row (text + images) in original order */}
                                            <Row className='justify-content-md-left'>
                                                    {contentSectionsForRow.map((section) => {
                                                    const fullIndex = campaignData.templates.customized_sections.findIndex(s => s === section);
                                                    if (section.type === 'text') {
                                                        return (
                                                            <Col
                                                                className='p-2'
                                                                xs={12}
                                                                md={contentSectionCount === 1 ? 12 : 6}
                                                                lg={contentSectionCount === 1 ? 12 : 4}
                                                            >
                                                            {/* <div style={{display: "inline-block", verticalAlign: "top", width: contentSectionWidth}}> */}
                                                                <div style={{display:'flex', alignItems:'center'}}>
                                                                    <Label
                                                                        htmlFor={`custom_description_${fullIndex}`}
                                                                        className="charts_filter_label"
                                                                        style={{marginBottom: '0px', display: 'flex', alignItems: 'center', gap: '4px'}}>
                                                                        {section.view === 'mobile' && <MobileIcon />}
                                                                        {section.label}
                                                                        
                                                                    <button type="button" className="btn btn-sm btn-link p-0" onClick={()=>toggleToolbar(fullIndex, true)} title="Edit" style={{color:'#000', marginLeft:'5px'}}>
                                                                        <svg width="24" height="24" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><g clipPath="url(#clip0_edit_ccp)"><path d="M19.1667 13.3333H15.6667C14.2666 13.3333 13.5666 13.3333 13.0318 13.6058C12.5614 13.8455 12.1789 14.2279 11.9392 14.6983C11.6667 15.2331 11.6667 15.9332 11.6667 17.3333V24.3333C11.6667 25.7335 11.6667 26.4335 11.9392 26.9683C12.1789 27.4387 12.5614 27.8212 13.0318 28.0608C13.5666 28.3333 14.2666 28.3333 15.6667 28.3333H22.6667C24.0669 28.3333 24.7669 28.3333 25.3017 28.0608C25.7721 27.8212 26.1546 27.4387 26.3943 26.9683C26.6667 26.4335 26.6667 25.7335 26.6667 24.3333V20.8333M16.6667 23.3333H18.0622C18.4698 23.3333 18.6737 23.3333 18.8655 23.2873C19.0355 23.2464 19.1981 23.1791 19.3472 23.0877C19.5154 22.9847 19.6595 22.8405 19.9478 22.5523L27.9167 14.5833C28.6071 13.893 28.6071 12.7737 27.9167 12.0833C27.2264 11.393 26.1071 11.393 25.4167 12.0833L17.4478 20.0523C17.1595 20.3405 17.0154 20.4847 16.9123 20.6528C16.8209 20.802 16.7536 20.9645 16.7128 21.1346C16.6667 21.3264 16.6667 21.5302 16.6667 21.9379V23.3333Z" stroke="#475467" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round"/></g><defs><clipPath id="clip0_edit_ccp"><rect width="20" height="20" fill="white" transform="translate(10 10)"/></clipPath></defs></svg>
                                                                    </button>
                                                                    </Label>
                                                                </div>
                                                                <div style={{display: showToolbarMap[fullIndex] ? 'flex' : 'none', alignItems:'center', gap:'6px', marginTop:'6px'}}>
                                                                    <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => execCmdOn(fullIndex, 'bold')}><strong>B</strong></button>
                                                                    <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => execCmdOn(fullIndex, 'italic')}><em>I</em></button>
                                                                    <input type="color" onChange={(e) => execCmdOn(fullIndex, 'foreColor', e.target.value)} title="Text color" style={{height:'28px', width:'28px', padding:0, border:'1px solid #ccc', borderRadius:'3px'}}/>
                                                                    <select className="form-select form-select-sm" style={{width:'auto'}} onChange={(e) => execCmdOn(fullIndex, 'fontSize', e.target.value)} defaultValue="3">
                                                                        <option value="2">Small</option>
                                                                        <option value="3">Normal</option>
                                                                        <option value="4">Medium</option>
                                                                        <option value="5">Large</option>
                                                                    </select>
                                                                    <label style={{marginLeft:'6px', fontSize:'0.85rem'}}>
                                                                        <input type="checkbox" checked={!!applyAllMap[fullIndex]} onChange={() => toggleApplyAll(fullIndex)} style={{marginRight:'4px'}}/>
                                                                        All
                                                                    </label>
                                                                    <button type="button" className="btn btn-sm btn-outline-secondary" onClick={()=>toggleToolbar(fullIndex, false)}>Close</button>
                                                                </div>
                                                                <div
                                                                    ref={(el) => setEditorRef(fullIndex, el)}
                                                                    contentEditable
                                                                    suppressContentEditableWarning
                                                                    onPaste={(e) => handlePaste(e, fullIndex)}
                                                                    onInput={(e)=>{
                                                                        const section = campaignData?.templates?.customized_sections?.[fullIndex];
                                                                        // const maxWords = section?.max_words || null;
                                                                        const maxWords = null;
                                                                        const textContent = e.currentTarget.innerText || e.currentTarget.textContent || '';
                                                                        const wordCount = countWords(textContent);

                                                                        if (maxWords && wordCount > maxWords) {
                                                                            // Revert to last valid HTML for this editor
                                                                            const prevHtml = previousValidHtmlRef.current[fullIndex] || '';
                                                                            e.currentTarget.innerHTML = prevHtml;
                                                                            // Move caret to end
                                                                            try {
                                                                                const range = document.createRange();
                                                                                range.selectNodeContents(e.currentTarget);
                                                                                range.collapse(false);
                                                                                const sel = window.getSelection();
                                                                                sel.removeAllRanges();
                                                                                sel.addRange(range);
                                                                            } catch (err) {}
                                                                            if (!wordLimitExceededRef.current[fullIndex]) {
                                                                                toast.error(`Max word limit of ${maxWords} exceeded for "${section?.label || 'this section'}".`);
                                                                                wordLimitExceededRef.current[fullIndex] = true;
                                                                            }
                                                                            return;
                                                                        }

                                                                        if (maxWords) {
                                                                            wordLimitExceededRef.current[fullIndex] = false;
                                                                        }

                                                                        const html = e.currentTarget.innerHTML;
                                                                        const normalizedHtml = normalizeWhitespace(html);
                                                                        let temp = [...selected_suggestion];
                                                                        temp[fullIndex] = normalizedHtml;
                                                                        setSelectedSuggestion(temp);
                                                                        previousValidHtmlRef.current[fullIndex] = normalizedHtml;
                                                                    }}
                                                                    style={{width: "97%", textWrap: 'wrap', height:'35px', overflowY: 'auto', border:'1px solid #b7b7b7', borderRadius:'4px', padding:'3px 8px', marginTop:'6px', backgroundColor:'#fff'}}
                                                                />
                                                            </Col>
                                                        )
                                                    }
                                                    if (section.type === 'img' || section.type === 'image' || section.type === 'bg_img') {
                                                        const imageUrl = selected_suggestion[fullIndex] || section.value || '';
                                                        return (
                                                            <Col
                                                                className='p-2'
                                                                xs={12}
                                                                md={contentSectionCount === 1 ? 12 : 6}
                                                                lg={contentSectionCount === 1 ? 12 : 4}
                                                            >
                                                            {/* <div style={{display: "inline-block", verticalAlign: "top", width: contentSectionWidth}}> */}
                                                                <label style={{fontWeight: "bold", display:'flex', alignItems:'center', gap:'4px'}}>
                                                                    {section.view === 'mobile' && <MobileIcon />}
                                                                    {section.label}
                                                                </label>
                                                                <div
                                                                    onClick={() => openImageAssetLibrary(fullIndex)}
                                                                    title={imageUrl}
                                                                    style={{
                                                                        cursor: 'pointer',
                                                                        width: "97%",
                                                                        marginTop: "0.5rem",
                                                                        padding: "0px 8px",
                                                                        border: "1px solid #b7b7b7",
                                                                        borderRadius: "4px",
                                                                        backgroundColor: "#fff",
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        gap: "8px",
                                                                        minHeight: "40px"
                                                                    }}
                                                                >
                                                                    <ImageWithFallback
                                                                        image_url={imageUrl}
                                                                        fallback_url={`https://storage.googleapis.com/scalex_ai_clients_lp_sections/no_preview_available.png`}
                                                                        alt={section.label}
                                                                        image_style={{ width: "35px", height: "35px", objectFit: "cover", borderRadius: "4px", border: "1px solid #eee" }}
                                                                    />
                                                                    <span style={{ flex: 1, minWidth: 0, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", fontSize: "0.9rem" }}>
                                                                        {imageUrl || "No image selected"}
                                                                    </span>
                                                                </div>
                                                            </Col>
                                                        )
                                                    }
                                                    return null;
                                                })}
                                            </Row>
                                        </Accordion.Body>
                                    </Accordion.Item>

                                    {/* Section for Dropdown Sections */}
                                    {(is_section_personalization_enabled && campaignData && campaignData?.templates && campaignData?.templates?.customized_sections && campaignData.templates.customized_sections.filter(section => section.type === 'dropdown').length > 0) && (
                                        <Accordion.Item eventKey="1">
                                            <Accordion.Header>
                                                <div className="ccp-accordion-header-inner">
                                                    <div className="ccp-accordion-header-left">
                                                        <svg width="20" height="20" viewBox="0 0 16 18" fill="currentColor" className="ccp-section-icon" aria-hidden="true">
                                                            <path fillRule="evenodd" clipRule="evenodd" d="M2.56681 0.5C2.12479 0.5 1.70086 0.675595 1.3883 0.988155C1.07574 1.30072 0.900146 1.72464 0.900146 2.16667V13.8333C0.900146 14.2754 1.07574 14.6993 1.3883 15.0118C1.70086 15.3244 2.12479 15.5 2.56681 15.5H14.2335C14.6755 15.5 15.0994 15.3244 15.412 15.0118C15.7246 14.6993 15.9001 14.2754 15.9001 13.8333V2.16667C15.9001 1.72464 15.7246 1.30072 15.412 0.988155C15.0994 0.675595 14.6755 0.5 14.2335 0.5H2.56681ZM7.56681 2.16667H2.56681V6.33333H7.56681V2.16667ZM2.56681 8H7.56681C8.00884 8 8.43276 7.8244 8.74532 7.51184C9.05788 7.19928 9.23348 6.77536 9.23348 6.33333V2.16667H14.2335V13.8333H2.56681V8Z" />
                                                        </svg>
                                                        <span className="ccp-accordion-header-title">Select Section</span>
                                                    </div>
                                                    <span className={`ccp-accordion-chevron ${activeAccordion.includes('1') ? 'open' : ''}`} aria-hidden="true">
                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                            <path d="M4.5 6L8 9.5L11.5 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                        </svg>
                                                    </span>
                                                </div>
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                <div style={{margin: "1rem 0.25rem", overflowX: "auto", whiteSpace: "nowrap"}}>
                                                    {(campaignData && campaignData?.templates && campaignData?.templates?.customized_sections) && 
                                                        campaignData.templates.customized_sections
                                                            .filter(section => section.type === 'dropdown')
                                                            .map((section, index) => {
                                                                // Find the actual index in the full array
                                                                const fullIndex = campaignData.templates.customized_sections.findIndex(s => s === section);
                                                                return (
                                                                    <div style={{display: "inline-block", verticalAlign: "top", width: dropdownSectionWidth}}>
                                                                        <Label className="charts_filter_label" style={{display:'flex', alignItems:'center', gap:'4px'}}>
                                                                            {section.view === 'mobile' && <MobileIcon />}
                                                                            {section.label}
                                                                        </Label>
                                                                        <ReMultiSelect
                                                                            id="select_keyword"
                                                                            className='campaign_summary_custom_section_dropdown'
                                                                            closeMenuOnSelect={true}
                                                                            placeholder={"Search Keyword ..."}
                                                                            components={ReMultiSelectAnimated()}
                                                                            menuPortalTarget={document.body}
                                                                            menuPosition="fixed"
                                                                            styles={dropdownStyles}
                                                                            value={{
                                                                                value: selected_suggestion[fullIndex] || section.options[0].value,
                                                                                label: section.options.find(opt => opt.value === (selected_suggestion[fullIndex] || section.options[0].value))?.label || section.options[0].label
                                                                            }}
                                                                            options={section.options.map(option => ({
                                                                                value: option.value,
                                                                                label: option.label
                                                                            }))}
                                                                            onChange={(selected) => {
                                                                                handleDropdownChange(fullIndex, selected.value);
                                                                            }}
                                                                        />
                                                                    </div>
                                                                )
                                                            })}
                                                </div>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    )}

                                    {/* Section for Form Customization (now conditional on isFormPersonalizationEnabled) */}
                                    {isFormPersonalizationEnabled && campaignData?.templates?.customized_sections?.some(section => section.type === 'form') && (
                                        <Accordion.Item eventKey="2">
                                            <Accordion.Header>
                                                <div className="ccp-accordion-header-inner">
                                                    <div className="ccp-accordion-header-left">
                                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" className="ccp-section-icon" aria-hidden="true">
                                                            <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
                                                        </svg>
                                                        <span className="ccp-accordion-header-title">Select Form</span>
                                                    </div>
                                                    <span className={`ccp-accordion-chevron ${activeAccordion.includes('2') ? 'open' : ''}`} aria-hidden="true">
                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                            <path d="M4.5 6L8 9.5L11.5 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                        </svg>
                                                    </span>
                                                </div>
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                <div style={{margin: "1rem 0.25rem", overflowX: "auto", whiteSpace: "nowrap"}}>
                                                    {(campaignData && campaignData?.templates && campaignData?.templates?.customized_sections) && 
                                                        campaignData.templates.customized_sections
                                                            .filter(section => section.type === 'form')
                                                            .map((section, index) => {
                                                                // Find the actual index in the full array
                                                                const fullIndex = campaignData.templates.customized_sections.findIndex(s => s === section);
                                                                return (
                                                                    <div style={{display: "inline-block", verticalAlign: "top", width: "100%"}}>
                                                                        <Label className="charts_filter_label" style={{display:'flex', alignItems:'center', gap:'4px'}}>
                                                                            {section.view === 'mobile' && <MobileIcon />}
                                                                            {section.label}
                                                                        </Label>
                                                                        <ReMultiSelect
                                                                            id={`form_select_${index}`}
                                                                            className='campaign_summary_custom_section_dropdown'
                                                                            closeMenuOnSelect={true}
                                                                            placeholder={"Select Form..."}
                                                                            components={ReMultiSelectAnimated()}
                                                                            menuPortalTarget={document.body}
                                                                            menuPosition="fixed"
                                                                            styles={dropdownStyles}
                                                                            value={{
                                                                                value: selected_suggestion[fullIndex] || section.options[0].value,
                                                                                label: section.options.find(opt => opt.value === (selected_suggestion[fullIndex] || section.options[0].value))?.label || section.options[0].label
                                                                            }}
                                                                            options={section.options.map(option => ({
                                                                                value: option.value,
                                                                                label: option.label
                                                                            }))}
                                                                            onChange={(selected) => {
                                                                                handleDropdownChange(fullIndex, selected.value);
                                                                            }}
                                                                        />
                                                                    </div>
                                                                )
                                                            })}
                                                </div>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    )}

                                    {/* Section for Exit Intent Customization (new) */}
                                    {isExitIntentPersonalizationEnabled && campaignData?.templates?.customized_sections?.some(section => section.type === 'exit_intent') && (
                                        <Accordion.Item eventKey="3">
                                            <Accordion.Header>
                                                <div className="ccp-accordion-header-inner">
                                                    <div className="ccp-accordion-header-left">
                                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" className="ccp-section-icon" aria-hidden="true">
                                                            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                                        </svg>
                                                        <span className="ccp-accordion-header-title">Select Exit Intent</span>
                                                    </div>
                                                    <span className={`ccp-accordion-chevron ${activeAccordion.includes('3') ? 'open' : ''}`} aria-hidden="true">
                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                            <path d="M4.5 6L8 9.5L11.5 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                        </svg>
                                                    </span>
                                                </div>
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                <div style={{margin: "1rem 0.25rem", overflowX: "auto", whiteSpace: "nowrap"}}>
                                                    {(campaignData && campaignData?.templates && campaignData?.templates?.customized_sections) && 
                                                        campaignData.templates.customized_sections
                                                            .filter(section => section.type === 'exit_intent')
                                                            .map((section, index) => {
                                                                // Find the actual index in the full array
                                                                const fullIndex = campaignData.templates.customized_sections.findIndex(s => s === section);
                                                                return (
                                                                    <div style={{display: "inline-block", verticalAlign: "top", width: "100%"}}>
                                                                        <Label className="charts_filter_label" style={{display:'flex', alignItems:'center', gap:'4px'}}>
                                                                            {section.view === 'mobile' && <MobileIcon />}
                                                                            {section.label}
                                                                        </Label>
                                                                        <ReMultiSelect
                                                                            id={`exit_intent_select_${index}`}
                                                                            className='campaign_summary_custom_section_dropdown'
                                                                            closeMenuOnSelect={true}
                                                                            placeholder={"Select Exit Intent..."}
                                                                            components={ReMultiSelectAnimated()}
                                                                            menuPortalTarget={document.body}
                                                                            menuPosition="fixed"
                                                                            styles={dropdownStyles}
                                                                            value={{
                                                                                value: selected_suggestion[fullIndex] || section.options[0].value,
                                                                                label: section.options.find(opt => opt.value === (selected_suggestion[fullIndex] || section.options[0].value))?.label || section.options[0].label
                                                                            }}
                                                                            options={section.options.map(option => ({
                                                                                value: option.value,
                                                                                label: option.label
                                                                            }))}
                                                                            onChange={(selected) => {
                                                                                handleDropdownChange(fullIndex, selected.value);
                                                                            }}
                                                                        />
                                                                    </div>
                                                                )
                                                            })}
                                                </div>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    )}

                                    {/* Section for Rearrange Sections */}
                                    {is_section_rearrangement_enabled && campaignData?.sections_rearrangement && (
                                        <Accordion.Item eventKey={
                                            (isFormPersonalizationEnabled && campaignData?.templates?.customized_sections?.some(section => section.type === 'form') && isExitIntentPersonalizationEnabled && campaignData?.templates?.customized_sections?.some(section => section.type === 'exit_intent')) ? "4" :
                                                (isFormPersonalizationEnabled && campaignData?.templates?.customized_sections?.some(section => section.type === 'form')) ? "3" :
                                                    (isExitIntentPersonalizationEnabled && campaignData?.templates?.customized_sections?.some(section => section.type === 'exit_intent')) ? "3" : "2"
                                        }>
                                            <Accordion.Header>
                                                <div className="ccp-accordion-header-inner">
                                                    <div className="ccp-accordion-header-left">
                                                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" className="ccp-section-icon" aria-hidden="true">
                                                            <g clipPath="url(#ccpClipRearrange)">
                                                                <path d="M1.125 2.25H13.5H1.125ZM1.125 15.75H13.5H1.125ZM4.5 9H16.875H4.5Z" fill="#8287FF" />
                                                                <path d="M1.125 2.25H13.5M1.125 15.75H13.5M4.5 9H16.875" stroke="#8287FF" strokeWidth="2" strokeLinecap="round" />
                                                            </g>
                                                            <defs>
                                                                <clipPath id="ccpClipRearrange">
                                                                    <rect width="18" height="18" fill="white" />
                                                                </clipPath>
                                                            </defs>
                                                        </svg>
                                                        <span className="ccp-accordion-header-title">Rearrange Sections</span>
                                                    </div>
                                                    <span
                                                        className={`ccp-accordion-chevron ${
                                                            activeAccordion.includes(
                                                                (isFormPersonalizationEnabled && campaignData?.templates?.customized_sections?.some(section => section.type === 'form') && isExitIntentPersonalizationEnabled && campaignData?.templates?.customized_sections?.some(section => section.type === 'exit_intent')) ? "4" :
                                                                    (isFormPersonalizationEnabled && campaignData?.templates?.customized_sections?.some(section => section.type === 'form')) ? "3" :
                                                                        (isExitIntentPersonalizationEnabled && campaignData?.templates?.customized_sections?.some(section => section.type === 'exit_intent')) ? "3" : "2"
                                                            ) ? 'open' : ''
                                                        }`}
                                                        aria-hidden="true"
                                                    >
                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                            <path d="M4.5 6L8 9.5L11.5 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                        </svg>
                                                    </span>
                                                </div>
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                <div style={{ margin: "0.25rem", overflowX: "auto", whiteSpace: "nowrap" }}>
                                                    <div className="rearrangement-scroll-row" style={{ marginTop: "0.25rem", overflowX: "auto", whiteSpace: "nowrap" }}>
                                                        { selected_rearrangement && selected_rearrangement.length > 0 ? 
                                                            selected_rearrangement.map((section, index) => {
                                                                return (
                                                                    <div
                                                                        key={index}
                                                                        style={{
                                                                            display: "inline-flex",
                                                                            flexDirection: "column",
                                                                            verticalAlign: "top",
                                                                            width: "33%",
                                                                            maxHeight: "300px",
                                                                            gap: "12px",
                                                                            marginBottom: "1rem",
                                                                            marginRight: "0.5rem",
                                                                            position: "relative",
                                                                            padding: "10px",
                                                                            borderRadius: "12px",
                                                                            border: "1px solid #EAECF0",
                                                                            background: "#FFFFFF",
                                                                            boxShadow: "0px 4px 32px -12px #10182833",
                                                                            boxSizing: "border-box"
                                                                        }}
                                                                    >
                                                                        <div style={{ display: "flex", alignItems: "center", gap: "0.35rem", width: "100%" }}>
                                                                            <div style={{ flex: 1, minWidth: 0 }}>
                                                                                <ReMultiSelect
                                                                                    id={`rearrangement_select_${index}`}
                                                                                    className='campaign_summary_custom_section_dropdown'
                                                                                    closeMenuOnSelect={true}
                                                                                    placeholder={"Select Rearrangement..."}
                                                                                    components={ReMultiSelectAnimated()}
                                                                                    menuPortalTarget={document.body}
                                                                                    menuPosition="fixed"
                                                                                    styles={dropdownStyles}
                                                                                    value={{
                                                                                        value: section || {},
                                                                                        label: section?.section_name || "Select Section"
                                                                                    }}
                                                                                    options={get_rearrangement_options(campaignData, selected_rearrangement, section?.section_query_selector)}
                                                                                    onChange={(selected) => {
                                                                                        handleRearrangementChange(index, selected.value);
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                            <div style={{ display: "flex", gap: "0.35rem", flexShrink: 0 }}>
                                                                                <button
                                                                                    size="sm"
                                                                                    onClick={() => handleAddRearrangement(index)}
                                                                                    style={{ padding: "0.05rem", fontSize: "0.75rem", backgroundColor: "transparent", border: "none" }}
                                                                                    title="Add section after this one"
                                                                                >
                                                                                    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                        <g filter="url(#filter0_d_223_4043)">
                                                                                        <rect x="2" y="1" width="40" height="40" rx="20" fill="none"/>
                                                                                        <rect x="2.5" y="1.5" width="39" height="39" rx="19.5" stroke="#D0D5DD"/>
                                                                                        <path d="M28 21.998H23V26.998C23 27.2633 22.8946 27.5176 22.7071 27.7052C22.5196 27.8927 22.2652 27.998 22 27.998C21.7348 27.998 21.4804 27.8927 21.2929 27.7052C21.1054 27.5176 21 27.2633 21 26.998V21.998H16C15.7348 21.998 15.4804 21.8927 15.2929 21.7052C15.1054 21.5176 15 21.2633 15 20.998C15 20.7328 15.1054 20.4785 15.2929 20.2909C15.4804 20.1034 15.7348 19.998 16 19.998H21V14.998C21 14.7328 21.1054 14.4785 21.2929 14.2909C21.4804 14.1034 21.7348 13.998 22 13.998C22.2652 13.998 22.5196 14.1034 22.7071 14.2909C22.8946 14.4785 23 14.7328 23 14.998V19.998H28C28.2652 19.998 28.5196 20.1034 28.7071 20.2909C28.8946 20.4785 29 20.7328 29 20.998C29 21.2633 28.8946 21.5176 28.7071 21.7052C28.5196 21.8927 28.2652 21.998 28 21.998Z" fill="#344054"/>
                                                                                        </g>
                                                                                        <defs>
                                                                                        <filter id="filter0_d_223_4043" x="0" y="0" width="44" height="44" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                                                                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                                                                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                                                                                        <feOffset dy="1"/>
                                                                                        <feGaussianBlur stdDeviation="1"/>
                                                                                        <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"/>
                                                                                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_223_4043"/>
                                                                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_223_4043" result="shape"/>
                                                                                        </filter>
                                                                                        </defs>
                                                                                    </svg>
                                                                                </button>
                                                                                <button
                                                                                    size="sm"
                                                                                    onClick={() => handleDeleteRearrangement(index)}
                                                                                    style={{ padding: "0.05rem", fontSize: "0.75rem", backgroundColor: "transparent", border: "none" }}
                                                                                    title="Delete this section"
                                                                                >
                                                                                    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                        <g filter="url(#filter0_d_223_4047)">
                                                                                        <rect x="2" y="1" width="40" height="40" rx="20" fill="white"/>
                                                                                        <rect x="2.5" y="1.5" width="39" height="39" rx="19.5" stroke="#D0D5DD"/>
                                                                                        <path d="M25 16.5V15.9C25 15.0599 25 14.6399 24.8365 14.319C24.6927 14.0368 24.4632 13.8073 24.181 13.6635C23.8601 13.5 23.4401 13.5 22.6 13.5H21.4C20.5599 13.5 20.1399 13.5 19.819 13.6635C19.5368 13.8073 19.3073 14.0368 19.1635 14.319C19 14.6399 19 15.0599 19 15.9V16.5M20.5 20.625V24.375M23.5 20.625V24.375M15.25 16.5H28.75M27.25 16.5V24.9C27.25 26.1601 27.25 26.7902 27.0048 27.2715C26.789 27.6948 26.4448 28.039 26.0215 28.2548C25.5402 28.5 24.9101 28.5 23.65 28.5H20.35C19.0899 28.5 18.4598 28.5 17.9785 28.2548C17.5552 28.039 17.211 27.6948 16.9952 27.2715C16.75 26.7902 16.75 26.1601 16.75 24.9V16.5" stroke="#344054" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                                                        </g>
                                                                                        <defs>
                                                                                        <filter id="filter0_d_223_4047" x="0" y="0" width="44" height="44" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                                                                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                                                                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                                                                                        <feOffset dy="1"/>
                                                                                        <feGaussianBlur stdDeviation="1"/>
                                                                                        <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"/>
                                                                                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_223_4047"/>
                                                                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_223_4047" result="shape"/>
                                                                                        </filter>
                                                                                        </defs>
                                                                                    </svg>
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                        {section?.display_rules?.type && (
                                                                            <div style={{ marginTop: "6px", paddingTop: "6px", borderTop: "1px solid #e9ecef", display: "flex", flexWrap: "wrap", gap: "4px", alignItems: "center", width: "100%" }}>
                                                                                <span style={{ fontSize: "0.7rem", color: "#6c757d", marginRight: "2px", flexShrink: 0 }}>Display Condition:</span>
                                                                                <span style={{ fontSize: "0.7rem", padding: "2px 6px", borderRadius: "4px", backgroundColor: "#e9ecef", color: "#495057", whiteSpace: "nowrap" }} title={section.display_rules.type === "previous_section" ? `Show after ${section.display_rules.seconds}s on previous section` : `Show after ${section.display_rules.seconds}s on page loads`}>
                                                                                    {section.display_rules.type === "previous_section" ? `Previous: ${section.display_rules.seconds}s` : `Page: ${section.display_rules.seconds}s`}
                                                                                </span>
                                                                            </div>
                                                                        )}
                                                                        <div
                                                                            style={{ position: "relative", width: "100%", marginTop: "1rem" }}
                                                                            onMouseEnter={() => setHoveredSectionImage({ view: "desktop", index })}
                                                                            onMouseLeave={() => setHoveredSectionImage(null)}
                                                                            onClick={() => sectionSettingsPopoverOpen && setSectionSettingsPopoverOpen(null)}
                                                                        >
                                                                            <div style={{ filter: hoveredSectionImage?.view === "desktop" && hoveredSectionImage?.index === index ? "blur(2px)" : "none", transition: "filter 0.2s" }}>
                                                                                <ImageWithFallback image_url={section.image_url} fallback_url={`https://storage.googleapis.com/scalex_ai_clients_lp_sections/no_preview_available.png`} alt={section.section_name} image_style={{ width: "100%", height: "auto", maxHeight: "150px" }} />
                                                                            </div>
                                                                            {hoveredSectionImage?.view === "desktop" && hoveredSectionImage?.index === index && (
                                                                                <button
                                                                                    type="button"
                                                                                    onClick={(e) => { e.stopPropagation(); setSectionSettingsPopoverOpen({ view: "desktop", index, ruleType: "previous_section", seconds: "" }); }}
                                                                                    style={{ position: "absolute", top: "4px", right: "4px", padding: "4px", backgroundColor: "rgba(255,255,255,0.9)", border: "1px solid #ccc", borderRadius: "4px", cursor: "pointer", zIndex: 2 }}
                                                                                    title="Section display settings"
                                                                                >
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#333333" viewBox="0 0 16 16"><path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492zM5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0z"/><path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52l-.094-.319z"/></svg>
                                                                                </button>
                                                                            )}
                                                                            {sectionSettingsPopoverOpen?.view === "desktop" && sectionSettingsPopoverOpen?.index === index && (
                                                                                <div onClick={(e) => e.stopPropagation()} style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", zIndex: 10, backgroundColor: "#fff", border: "1px solid #ccc", borderRadius: "8px", padding: "12px", minWidth: "220px", boxShadow: "0 2px 12px rgba(0,0,0,0.15)" }}>
                                                                                    <div style={{ marginBottom: "8px", fontWeight: 600, fontSize: "0.875rem" }}>Show section after</div>
                                                                                    <label style={{ display: "block", marginBottom: "6px", fontSize: "0.8rem" }}>
                                                                                        <input type="radio" name={`display-rule-desktop-${index}`} checked={sectionSettingsPopoverOpen.ruleType === "previous_section"} onChange={() => setSectionSettingsPopoverOpen(prev => prev ? { ...prev, ruleType: "previous_section" } : null)} /> Time spent on previous section
                                                                                    </label>
                                                                                    <label style={{ display: "block", marginBottom: "8px", fontSize: "0.8rem" }}>
                                                                                        <input type="radio" name={`display-rule-desktop-${index}`} checked={sectionSettingsPopoverOpen.ruleType === "overall_page"} onChange={() => setSectionSettingsPopoverOpen(prev => prev ? { ...prev, ruleType: "overall_page" } : null)} /> Time spent on overall page
                                                                                    </label>
                                                                                    <div style={{ marginBottom: "8px" }}>
                                                                                        <input type="number" min={1} placeholder="Time (seconds)" value={sectionSettingsPopoverOpen.seconds} onChange={(e) => setSectionSettingsPopoverOpen(prev => prev ? { ...prev, seconds: e.target.value } : null)} style={{ width: "100%", padding: "4px 8px", fontSize: "0.875rem" }} />
                                                                                    </div>
                                                                                    <div style={{ display: "flex", gap: "8px", justifyContent: "flex-end" }}>
                                                                                        <button type="button" onClick={() => handleAddDisplayRule("desktop", index, { type: sectionSettingsPopoverOpen.ruleType, seconds: sectionSettingsPopoverOpen.seconds })} style={{ padding: "4px 10px", fontSize: "0.8rem" }}>Add</button>
                                                                                        <button type="button" onClick={() => setSectionSettingsPopoverOpen(null)} style={{ padding: "4px 10px", fontSize: "0.8rem" }}>Cancel</button>
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                )
                                                            })
                                                            :
                                                            <div style={{ display: "inline-block", verticalAlign: "top", width: "33%", height: "100px", border: "1px solid #ccc", borderRadius: "5px", position: "relative" }}>
                                                                <button
                                                                    size="sm"
                                                                    onClick={() => handleAddRearrangement(0)}
                                                                    style={{ padding: "0.05rem", fontSize: "0.75rem", backgroundColor: "transparent", border: "none", width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}
                                                                >
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" className="bi bi-plus" viewBox="0 0 16 16">
                                                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                                                                    </svg>
                                                                    Add Section
                                                                </button>
                                                            </div>
                                                        }
                                                    </div>
                                                    <div className="sxi-section-divider">
                                                        <div className="sxi-section-divider__line" />
                                                        <span className="sxi-section-divider__label">Mobile Experience</span>
                                                        <div className="sxi-section-divider__line" />
                                                    </div>
                                                    <div style={{ marginTop: "1rem" }}>
                                                        <Button
                                                            type="button"
                                                            variant={'primary'}
                                                            // className={'sxi_primary_blue_btn btn-height'}
                                                            className={'back-button btn-height'}
                                                            onClick={() => {
                                                                if (selected_rearrangement_mobile.length > 0) {
                                                                    setSelectedRearrangementMobile([]);
                                                                    setShowMobileRearrangement(false);
                                                                } else {
                                                                    setShowMobileRearrangement(true);
                                                                }
                                                            }}
                                                        >
                                                            {selected_rearrangement_mobile.length > 0 ? "Delete Mobile Experience" : "Add Mobile Experience"}
                                                        </Button>
                                                    </div>
                                                    {showMobileRearrangement && (
                                                        <>
                                                            <Label className="charts_filter_label" style={{ marginBottom: "0.5rem", marginTop: "1rem", display: "block" }}>Mobile</Label>
                                                            <div className="rearrangement-scroll-row" style={{ marginTop: "0.25rem", overflowX: "auto", whiteSpace: "nowrap" }}>
                                                                { selected_rearrangement_mobile && selected_rearrangement_mobile.length > 0 ?
                                                                    selected_rearrangement_mobile.map((section, index) => (
                                                                        <div
                                                                            key={`mobile-${index}`}
                                                                            style={{
                                                                                display: "inline-flex",
                                                                                flexDirection: "column",
                                                                                verticalAlign: "top",
                                                                                width: "33%",
                                                                                maxHeight: "300px",
                                                                                gap: "12px",
                                                                                marginBottom: "1rem",
                                                                                marginRight: "0.5rem",
                                                                                position: "relative",
                                                                                padding: "10px",
                                                                                borderRadius: "12px",
                                                                                border: "1px solid #EAECF0",
                                                                                background: "#FFFFFF",
                                                                                boxShadow: "0px 4px 32px -12px #10182833",
                                                                                boxSizing: "border-box"
                                                                            }}
                                                                        >
                                                                            <div style={{ display: "flex", alignItems: "center", gap: "0.35rem", width: "100%" }}>
                                                                                <div style={{ flex: 1, minWidth: 0 }}>
                                                                                    <ReMultiSelect
                                                                                        id={`rearrangement_select_mobile_${index}`}
                                                                                        className='campaign_summary_custom_section_dropdown'
                                                                                        closeMenuOnSelect={true}
                                                                                        placeholder={"Select Rearrangement..."}
                                                                                        components={ReMultiSelectAnimated()}
                                                                                        menuPortalTarget={document.body}
                                                                                        menuPosition="fixed"
                                                                                        styles={dropdownStyles}
                                                                                        value={{
                                                                                            value: section || {},
                                                                                            label: section?.section_name || "Select Section"
                                                                                        }}
                                                                                        options={get_rearrangement_options(campaignData, selected_rearrangement_mobile, section?.section_query_selector)}
                                                                                        onChange={(selected) => {
                                                                                            handleRearrangementChangeMobile(index, selected.value);
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                                <div style={{ display: "flex", gap: "0.35rem", flexShrink: 0 }}>
                                                                                    <button
                                                                                        size="sm"
                                                                                        onClick={() => handleAddRearrangementMobile(index)}
                                                                                        style={{ padding: "0.05rem", fontSize: "0.75rem", backgroundColor: "transparent", border: "none" }}
                                                                                        title="Add section after this one"
                                                                                    >
                                                                                        <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                            <g filter="url(#filter0_d_223_4043)">
                                                                                            <rect x="2" y="1" width="40" height="40" rx="20" fill="none"/>
                                                                                            <rect x="2.5" y="1.5" width="39" height="39" rx="19.5" stroke="#D0D5DD"/>
                                                                                            <path d="M28 21.998H23V26.998C23 27.2633 22.8946 27.5176 22.7071 27.7052C22.5196 27.8927 22.2652 27.998 22 27.998C21.7348 27.998 21.4804 27.8927 21.2929 27.7052C21.1054 27.5176 21 27.2633 21 26.998V21.998H16C15.7348 21.998 15.4804 21.8927 15.2929 21.7052C15.1054 21.5176 15 21.2633 15 20.998C15 20.7328 15.1054 20.4785 15.2929 20.2909C15.4804 20.1034 15.7348 19.998 16 19.998H21V14.998C21 14.7328 21.1054 14.4785 21.2929 14.2909C21.4804 14.1034 21.7348 13.998 22 13.998C22.2652 13.998 22.5196 14.1034 22.7071 14.2909C22.8946 14.4785 23 14.7328 23 14.998V19.998H28C28.2652 19.998 28.5196 20.1034 28.7071 20.2909C28.8946 20.4785 29 20.7328 29 20.998C29 21.2633 28.8946 21.5176 28.7071 21.7052C28.5196 21.8927 28.2652 21.998 28 21.998Z" fill="#344054"/>
                                                                                            </g>
                                                                                            <defs>
                                                                                            <filter id="filter0_d_223_4043" x="0" y="0" width="44" height="44" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                                                                            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                                                                            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                                                                                            <feOffset dy="1"/>
                                                                                            <feGaussianBlur stdDeviation="1"/>
                                                                                            <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"/>
                                                                                            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_223_4043"/>
                                                                                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_223_4043" result="shape"/>
                                                                                            </filter>
                                                                                            </defs>
                                                                                        </svg>
                                                                                    </button>
                                                                                    <button
                                                                                        size="sm"
                                                                                        onClick={() => handleDeleteRearrangementMobile(index)}
                                                                                        style={{ padding: "0.05rem", fontSize: "0.75rem", backgroundColor: "transparent", border: "none" }}
                                                                                        title="Delete this section"
                                                                                    >
                                                                                        <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                            <g filter="url(#filter0_d_223_4047)">
                                                                                            <rect x="2" y="1" width="40" height="40" rx="20" fill="white"/>
                                                                                            <rect x="2.5" y="1.5" width="39" height="39" rx="19.5" stroke="#D0D5DD"/>
                                                                                            <path d="M25 16.5V15.9C25 15.0599 25 14.6399 24.8365 14.319C24.6927 14.0368 24.4632 13.8073 24.181 13.6635C23.8601 13.5 23.4401 13.5 22.6 13.5H21.4C20.5599 13.5 20.1399 13.5 19.819 13.6635C19.5368 13.8073 19.3073 14.0368 19.1635 14.319C19 14.6399 19 15.0599 19 15.9V16.5M20.5 20.625V24.375M23.5 20.625V24.375M15.25 16.5H28.75M27.25 16.5V24.9C27.25 26.1601 27.25 26.7902 27.0048 27.2715C26.789 27.6948 26.4448 28.039 26.0215 28.2548C25.5402 28.5 24.9101 28.5 23.65 28.5H20.35C19.0899 28.5 18.4598 28.5 17.9785 28.2548C17.5552 28.039 17.211 27.6948 16.9952 27.2715C16.75 26.7902 16.75 26.1601 16.75 24.9V16.5" stroke="#344054" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                                                            </g>
                                                                                            <defs>
                                                                                            <filter id="filter0_d_223_4047" x="0" y="0" width="44" height="44" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                                                                            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                                                                            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                                                                                            <feOffset dy="1"/>
                                                                                            <feGaussianBlur stdDeviation="1"/>
                                                                                            <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"/>
                                                                                            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_223_4047"/>
                                                                                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_223_4047" result="shape"/>
                                                                                            </filter>
                                                                                            </defs>
                                                                                        </svg>
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                            {section?.display_rules?.type && (
                                                                                <div style={{ marginTop: "6px", paddingTop: "6px", borderTop: "1px solid #e9ecef", display: "flex", flexWrap: "wrap", gap: "4px", alignItems: "center", width: "100%" }}>
                                                                                    <span style={{ fontSize: "0.7rem", color: "#6c757d", marginRight: "2px", flexShrink: 0 }}>Display Condition:</span>
                                                                                    <span style={{ fontSize: "0.7rem", padding: "2px 6px", borderRadius: "4px", backgroundColor: "#e9ecef", color: "#495057", whiteSpace: "nowrap" }} title={section.display_rules.type === "previous_section" ? `Show after ${section.display_rules.seconds}s on previous section` : `Show after ${section.display_rules.seconds}s on page loads`}>
                                                                                        {section.display_rules.type === "previous_section" ? `Previous: ${section.display_rules.seconds}s` : `Page: ${section.display_rules.seconds}s`}
                                                                                    </span>
                                                                                </div>
                                                                            )}
                                                                            <div
                                                                                style={{ position: "relative", width: "100%", marginTop: "1rem" }}
                                                                                onMouseEnter={() => setHoveredSectionImage({ view: "mobile", index })}
                                                                                onMouseLeave={() => setHoveredSectionImage(null)}
                                                                                onClick={() => sectionSettingsPopoverOpen && setSectionSettingsPopoverOpen(null)}
                                                                            >
                                                                                <div style={{ filter: hoveredSectionImage?.view === "mobile" && hoveredSectionImage?.index === index ? "blur(2px)" : "none", transition: "filter 0.2s" }}>
                                                                                    <ImageWithFallback image_url={section.image_url} fallback_url={`https://storage.googleapis.com/scalex_ai_clients_lp_sections/no_preview_available.png`} alt={section.section_name} image_style={{ width: "100%", height: "auto", maxHeight: "150px" }} />
                                                                                </div>
                                                                                {hoveredSectionImage?.view === "mobile" && hoveredSectionImage?.index === index && (
                                                                                    <button
                                                                                        type="button"
                                                                                        onClick={(e) => { e.stopPropagation(); setSectionSettingsPopoverOpen({ view: "mobile", index, ruleType: "previous_section", seconds: "" }); }}
                                                                                        style={{ position: "absolute", top: "4px", right: "4px", padding: "4px", backgroundColor: "rgba(255,255,255,0.9)", border: "1px solid #ccc", borderRadius: "4px", cursor: "pointer", zIndex: 2 }}
                                                                                        title="Section display settings"
                                                                                    >
                                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#333333" viewBox="0 0 16 16"><path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492zM5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0z"/><path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52l-.094-.319z"/></svg>
                                                                                    </button>
                                                                                )}
                                                                                {sectionSettingsPopoverOpen?.view === "mobile" && sectionSettingsPopoverOpen?.index === index && (
                                                                                    <div onClick={(e) => e.stopPropagation()} style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", zIndex: 10, backgroundColor: "#fff", border: "1px solid #ccc", borderRadius: "8px", padding: "12px", minWidth: "220px", boxShadow: "0 2px 12px rgba(0,0,0,0.15)" }}>
                                                                                        <div style={{ marginBottom: "8px", fontWeight: 600, fontSize: "0.875rem" }}>Show section after</div>
                                                                                        <label style={{ display: "block", marginBottom: "6px", fontSize: "0.8rem" }}>
                                                                                            <input type="radio" name={`display-rule-mobile-${index}`} checked={sectionSettingsPopoverOpen.ruleType === "previous_section"} onChange={() => setSectionSettingsPopoverOpen(prev => prev ? { ...prev, ruleType: "previous_section" } : null)} /> Time spent on previous section
                                                                                        </label>
                                                                                        <label style={{ display: "block", marginBottom: "8px", fontSize: "0.8rem" }}>
                                                                                            <input type="radio" name={`display-rule-mobile-${index}`} checked={sectionSettingsPopoverOpen.ruleType === "overall_page"} onChange={() => setSectionSettingsPopoverOpen(prev => prev ? { ...prev, ruleType: "overall_page" } : null)} /> Time spent on overall page
                                                                                        </label>
                                                                                        <div style={{ marginBottom: "8px" }}>
                                                                                            <input type="number" min={1} placeholder="Time (seconds)" value={sectionSettingsPopoverOpen.seconds} onChange={(e) => setSectionSettingsPopoverOpen(prev => prev ? { ...prev, seconds: e.target.value } : null)} style={{ width: "100%", padding: "4px 8px", fontSize: "0.875rem" }} />
                                                                                        </div>
                                                                                        <div style={{ display: "flex", gap: "8px", justifyContent: "flex-end" }}>
                                                                                            <button type="button" onClick={() => handleAddDisplayRule("mobile", index, { type: sectionSettingsPopoverOpen.ruleType, seconds: sectionSettingsPopoverOpen.seconds })} style={{ padding: "4px 10px", fontSize: "0.8rem" }}>Add</button>
                                                                                            <button type="button" onClick={() => setSectionSettingsPopoverOpen(null)} style={{ padding: "4px 10px", fontSize: "0.8rem" }}>Cancel</button>
                                                                                        </div>
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    ))
                                                                    :
                                                                    <div style={{ display: "inline-block", verticalAlign: "top", width: "33%", height: "100px", border: "1px solid #ccc", borderRadius: "5px", position: "relative" }}>
                                                                        <button
                                                                            size="sm"
                                                                            onClick={() => handleAddRearrangementMobile(0)}
                                                                            style={{ padding: "0.05rem", fontSize: "0.75rem", backgroundColor: "transparent", border: "none", width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}
                                                                        >
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" className="bi bi-plus" viewBox="0 0 16 16">
                                                                                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                                                                            </svg>
                                                                            Add Section
                                                                        </button>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </>
                                                    )}
                                                </div>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    )}

                                    {/* Generate Preview Accordion */}
                                    <Accordion.Item eventKey={
                                        (isFormPersonalizationEnabled && campaignData?.templates?.customized_sections?.some(section => section.type === 'form') && isExitIntentPersonalizationEnabled && campaignData?.templates?.customized_sections?.some(section => section.type === 'exit_intent') && campaignData?.sections_rearrangement) ? "6" :
                                        (isFormPersonalizationEnabled && campaignData?.templates?.customized_sections?.some(section => section.type === 'form') && isExitIntentPersonalizationEnabled && campaignData?.templates?.customized_sections?.some(section => section.type === 'exit_intent')) ? "5" :
                                        (isFormPersonalizationEnabled && campaignData?.templates?.customized_sections?.some(section => section.type === 'form') && campaignData?.sections_rearrangement) ? "5" :
                                        (isExitIntentPersonalizationEnabled && campaignData?.templates?.customized_sections?.some(section => section.type === 'exit_intent') && campaignData?.sections_rearrangement) ? "5" :
                                        (isFormPersonalizationEnabled && campaignData?.templates?.customized_sections?.some(section => section.type === 'form')) ? "4" :
                                        (isExitIntentPersonalizationEnabled && campaignData?.templates?.customized_sections?.some(section => section.type === 'exit_intent')) ? "4" :
                                        (campaignData?.sections_rearrangement) ? "4" : "3"
                                    }>
                                        <Accordion.Header>
                                            <div className="ccp-accordion-header-inner">
                                                <div className="ccp-accordion-header-left">
                                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" className="ccp-section-icon" aria-hidden="true">
                                                        <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
                                                    </svg>
                                                    <span className="ccp-accordion-header-title">Generate Preview</span>
                                                </div>
                                                <span
                                                    className={`ccp-accordion-chevron ${
                                                        activeAccordion.includes(
                                                            (isFormPersonalizationEnabled && campaignData?.templates?.customized_sections?.some(section => section.type === 'form') && isExitIntentPersonalizationEnabled && campaignData?.templates?.customized_sections?.some(section => section.type === 'exit_intent') && campaignData?.sections_rearrangement) ? "6" :
                                                                (isFormPersonalizationEnabled && campaignData?.templates?.customized_sections?.some(section => section.type === 'form') && isExitIntentPersonalizationEnabled && campaignData?.templates?.customized_sections?.some(section => section.type === 'exit_intent')) ? "5" :
                                                                    (isFormPersonalizationEnabled && campaignData?.templates?.customized_sections?.some(section => section.type === 'form') && campaignData?.sections_rearrangement) ? "5" :
                                                                        (isExitIntentPersonalizationEnabled && campaignData?.templates?.customized_sections?.some(section => section.type === 'exit_intent') && campaignData?.sections_rearrangement) ? "5" :
                                                                            (isFormPersonalizationEnabled && campaignData?.templates?.customized_sections?.some(section => section.type === 'form')) ? "4" :
                                                                                (isExitIntentPersonalizationEnabled && campaignData?.templates?.customized_sections?.some(section => section.type === 'exit_intent')) ? "4" :
                                                                                    (campaignData?.sections_rearrangement) ? "4" : "3"
                                                        ) ? 'open' : ''
                                                    }`}
                                                    aria-hidden="true"
                                                >
                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                        <path d="M4.5 6L8 9.5L11.5 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                </span>
                                            </div>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <Row className='justify-content-md-left my-2' lg={2} xs={1}>
                                                <Col style={{textAlign: "left"}}>
                                                    {generate_btn_loading ?
                                                        <Button className='mt-3 sxi_primary_blue_btn btn-height'
                                                                disabled><Spinner size="sm"
                                                            animation="border"/></Button>
                                                        :
                                                        <>
                                                            <Button
                                                                className='mt-3 sxi_primary_blue_btn btn-height'
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    handleSaveDescriptionToSheet(true)
                                                                }}>Generate Preview</Button>
                                                        </>
                                                    }
                                                </Col>
                                            </Row>

                                            <Row className='justify-content-md-left mb-3' lg={1} xs={1}>
                                                {(show_landing_page && !generate_btn_loading) &&
                                                    <>
                                                        <div className='py-4 mt-4' style={{ width: "100%", backgroundColor: "white", borderRadius: "5px" }}>
                                                            {(() => {
                                                                const fullUrl = encodeURI(`${campaignData.landing_page_urls}?sxi_content=${generate_preview_contentKey}&_cb=${epochTime()}`);
                                                                const baseUrl = (() => { try { const u = new URL(campaignData.landing_page_urls); return u.origin + u.pathname; } catch { return campaignData.landing_page_urls; } })();
                                                                return (
                                                                    <div style={{ display: 'flex', alignItems: 'center', border: '1px solid #dee2e6', borderRadius: '8px', overflow: 'hidden', maxWidth: '480px' }}>
                                                                        <div style={{ display: 'flex', alignItems: 'center', padding: '0 12px', color: '#6c757d', flexShrink: 0 }}>
                                                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                                                <circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/>
                                                                                <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
                                                                            </svg>
                                                                        </div>
                                                                        <a
                                                                            href={fullUrl}
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                            title={fullUrl}
                                                                            style={{
                                                                                flex: 1, padding: '7px 4px', fontSize: '13px',
                                                                                color: '#495057', textDecoration: 'none',
                                                                                overflow: 'hidden', whiteSpace: 'nowrap',
                                                                                textOverflow: 'ellipsis', display: 'block'
                                                                            }}
                                                                        >
                                                                            {baseUrl}...
                                                                        </a>
                                                                        <button
                                                                            className='btn-height btn-back'
                                                                            onClick={() => {
                                                                                navigator.clipboard.writeText(fullUrl);
                                                                                setUrlCopied(true);
                                                                                setTimeout(() => setUrlCopied(false), 2000);
                                                                            }}
                                                                            style={{
                                                                                padding: '10px 20px',
                                                                                color: '#000000', border: 'none',
                                                                                fontWeight: '500', fontSize: '14px',
                                                                                cursor: 'pointer', flexShrink: 0,
                                                                                transition: 'background-color 0.2s ease',
                                                                                whiteSpace: 'nowrap'
                                                                            }}
                                                                        >
                                                                            {urlCopied ? 'Copied!' : 'Copy URL'}
                                                                        </button>
                                                                    </div>
                                                                );
                                                            })()}
                                                        </div>
                                                    </>
                                                }
                                            </Row>
                                        </Accordion.Body>
                                    </Accordion.Item>

                                </Accordion>
                                    </div>
                                    <div className="bottom-actions">
                                        {(() => {
                                            const visibleTabs = getVisibleTabs();
                                            const activeTabKey = activeAccordion?.[0] ?? '0';
                                            const currentIndex = visibleTabs.indexOf(activeTabKey);

                                            const isPrevDisabled = currentIndex <= 0;
                                            const isNextDisabled = currentIndex < 0 || currentIndex >= visibleTabs.length - 1;

                                            return (
                                                <>
                                                    <div className="actions-left">
                                                        <button
                                                            type="button"
                                                            className="btn-secondary"
                                                            onClick={() => {
                                                                if (currentIndex > 0) {
                                                                    setActiveAccordion([visibleTabs[currentIndex - 1]]);
                                                                }
                                                            }}
                                                            disabled={isPrevDisabled}
                                                        >
                                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" className="btn-icon" aria-hidden="true">
                                                                <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
                                                            </svg>
                                                            Previous
                                                        </button>
                                                    </div>

                                                    <div className="actions-right">
                                                        <button
                                                            type="button"
                                                            className="btn-primary"
                                                            onClick={() => {
                                                                if (currentIndex >= 0 && currentIndex < visibleTabs.length - 1) {
                                                                    setActiveAccordion([visibleTabs[currentIndex + 1]]);
                                                                }
                                                            }}
                                                            disabled={isNextDisabled}
                                                        >
                                                            Next
                                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" className="btn-icon" aria-hidden="true">
                                                                <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z" />
                                                            </svg>
                                                        </button>
                                                    </div>
                                                </>
                                            );
                                        })()}
                                    </div>
                                </div>
                            </Container>

                            <div className="save-back-row">
                                <div className="actions-left">
                                    {readOnlyVariant ? (
                                        <span className="text-muted small">This variant can't change while its test is running or after it has completed. Pause the test to edit it.</span>
                                    ) : apply_customization_btn_loading ? (
                                        <Button className='sxi_primary_blue_btn btn-height' disabled><Spinner size="sm" animation="border"/></Button>
                                    ) : (
                                        <Button className='sxi_primary_blue_btn btn-height' onClick={(e) => { e.preventDefault();
                                            setApplyCustomizeBtnLoading(true);
                                            handleSaveDescriptionToSheet(false) }}>Save and Return</Button>
                                    )}
                                    <button
                                        type="button"
                                        className="back-button btn-height"
                                        onClick={handleBack}
                                    >
                                        {/* <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" className="btn-icon" aria-hidden="true">
                                            <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
                                        </svg> */}
                                        Back
                                    </button>
                                </div>
                            </div>

                            {/* Image Asset Library Modal */}
                            <Modal show={showImageLibrary} onHide={() => setShowImageLibrary(false)} size="lg">
                                <Modal.Header closeButton>
                                    <Modal.Title>Select Image</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    {imageAssetsLoading ?
                                        <div className='main_conatiner_spinner'>
                                            <Spinner animation="border"/>
                                        </div>
                                        :
                                        <div className="row">
                                            {imageAssets && imageAssets.length > 0 ? imageAssets.map((asset) => {
                                                const previewUrl = getFilePreviewUrl(asset);
                                                return (
                                                    <div className="col-md-4 mb-3" key={asset._id}>
                                                        <div className="card h-100" style={{cursor:'pointer'}} onClick={() => handleSelectImageAsset(asset)}>
                                                            <img src={previewUrl} alt={asset.title} style={{width:'100%', height:'150px', objectFit:'cover'}}/>
                                                            <div className="card-body">
                                                                <div style={{fontSize:'0.85rem', fontWeight:600}}>{asset.title}</div>
                                                                <div style={{fontSize:'0.75rem', color:'#666'}}>Type: Image</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            }) : (
                                                <div className="col-12">
                                                    <div className="text-muted">No images found in assets.</div>
                                                </div>
                                            )}
                                        </div>
                                    }
                                </Modal.Body>
                            </Modal>
                        </>
                        :
                        <div className='main_conatiner_spinner'>
                            <Spinner animation="border"/>
                        </div>
                    }
                </>
            }
        </div>
    )
}

export default ABTestVariantPersonalization

function check_loc_personalization(query) {
    const pattern = /\{\s*(\w+)?\s*(sxi_city|sxi_zipcode)(?:\s*:\s*([^}]+))?\s*\}/i;

    const match = query.match(pattern);

    if (match) {
        const key = match[2];
        return {
            is_loc_personalized: true,
            loc_personalization_type: key === "sxi_city" ? "city" : "zip_code"
        };
    } else {
        return {
            is_loc_personalized: false,
            loc_personalization_type: null
        };
    }
}

function get_rearrangement_options(campaignData, selectedSections = [], currentSectionSelector = null) {
    const usedSelectors = new Set(
        selectedSections
            .map(s => s?.section_id)
            .filter(Boolean)
    );
    if (currentSectionSelector) {
        usedSelectors.delete(currentSectionSelector);
    }

    let rearrangement_options = [];
    let sections_rearrangement = campaignData?.sections_rearrangement || [];
    sections_rearrangement.forEach(option_iter => {
        if (!usedSelectors.has(option_iter.section_id)) {
            rearrangement_options.push({
                value: option_iter,
                label: option_iter.section_name || "Section"
            });
        }
    });
    let approved_sections = campaignData?.approved_sections || [];
    approved_sections.forEach(option_iter => {
        if (!usedSelectors.has(option_iter.section_id)) {
            rearrangement_options.push({
                value: option_iter,
                label: "(SXI) " + (option_iter.section_name || "Section")
            });
        }
    });
    return rearrangement_options;
}

// Used to format Date in yyyy-mm-dd format
function formatDate(date, is_increase_date = false) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + (is_increase_date ? d.getDate() + 1 : d.getDate()),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [year, month, day].join('-');
} 


function createClientScreenshotDir(clientName, landingUrl) {
    // Sanitize URL for folder name
    const sanitizedUrl = sanitizeUrlForFolder(landingUrl);
    // Return a URL path instead of creating directories (browser environment)
    return `${clientName}/${sanitizedUrl}`;
}

function epochTime() {
    return Date.now();
}

function sanitizeUrlForFolder(url) {
    // Remove @ prefix if present
    let cleanUrl = url.startsWith('@') ? url.substring(1) : url;
    
    // Remove protocol (http://, https://)
    cleanUrl = cleanUrl.replace(/^https?:\/\//, '');
    
    // Replace invalid characters with underscores (browser-safe characters)
    cleanUrl = cleanUrl.replace(/[<>:"/\\|?*]/g, '_');
    
    // Remove trailing dots and spaces
    cleanUrl = cleanUrl.replace(/\.+$/, '').trim();
    
    // Ensure it's not empty
    if (!cleanUrl) {
      cleanUrl = 'default_url';
    }
    
    return cleanUrl;
}